import * as React from "react"

const SvgComponent = (props) => (
    <svg
        width={604}
        height={440}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox={`0 0 604 440`}
    >
        <path
            d="m91.91 418.281-30.966 17.994a5.865 5.865 0 0 1-5.3 0l-16.6-9.584 4.48-2.6v-1.219l3.073 1.764.44-.253.005-2.563-.008 3.07 6.7 3.843.423-.245v.492l8.844 5.077 4.1-2.392v-1.09l.938.538 1.375-.8 2.723-1.589 4.746-2.775v-1.374l1.187.683 4.094-2.4V421.8l.914.527 4.094-2.4.008-3.069-4.286-2.463-.82.481v-.948l-4.288-2.465-.822.479v-.947l-4.286-2.463-.824.481v-.949l-4.286-2.463-.82.479v-.946l-4.286-2.463-.82.479v-.952l-4.293-2.459-.82.479v-.952l-4.29-2.462-.818.479v-.946l-4.293-2.466-.818.479v-.947l-4.293-2.463-4.09 2.393v1.062l-1.03-.59 2.4-1.377.006-3.069-4.285-2.463-4.1 2.393v1.059l-.913-.524-4.1 2.395v1.064l-.918-.529-4.1 2.395v1.065l-.918-.529-4.09 2.395v1.094l-.947-.543-4.092 2.392-.008 3.069 9.084 5.219.538-.314.006-2.448-.008 3.07 6.091 3.5-4.429 2.571v1.226l-20.3-11.72a1.878 1.878 0 0 1-1.1-1.545l-.009 3.068a1.88 1.88 0 0 0 1.1 1.547l53.835 31.08a5.864 5.864 0 0 0 5.3 0l30.964-18a1.863 1.863 0 0 0 1.085-1.524c0-1.023.003-2.046.008-3.069a1.86 1.86 0 0 1-1.088 1.528Z"
            fill="#331083"
        />
        <path
            d="m46.352 393.408-4.1 2.394-4.286-2.464 4.09-2.393 4.296 2.463ZM40.564 395.891l-4.094 2.4-10.56-6.065 4.1-2.394 10.554 6.059ZM51.46 396.341l-4.1 2.391-4.288-2.462 4.093-2.395 4.294 2.466ZM32.852 397.268l-4.1 2.394-7.863-4.516 4.1-2.394 7.863 4.516ZM56.563 399.271l-4.1 2.393-4.286-2.461 4.094-2.393 4.292 2.461ZM37.695 400.054l-4.1 2.393-4.29-2.46 4.1-2.394 4.29 2.461ZM50.537 401.621l-4.09 2.394-4.294-2.461 4.1-2.395 4.284 2.462ZM30.533 401.752l-4.1 2.392-10.557-6.062 4.096-2.394 10.561 6.064ZM61.67 402.202l-4.1 2.395-4.29-2.462 4.1-2.392 4.29 2.459ZM42.52 402.822l-4.1 2.394-4.29-2.46 4.1-2.393 4.29 2.459ZM24.02 403.848l-4.1 2.392-9.083-5.217 4.09-2.392 9.094 5.217ZM55.427 404.424l-4.1 2.394-4.286-2.463 4.1-2.393 4.286 2.462ZM35.413 404.552l-4.1 2.394-4.286-2.463 4.1-2.394 4.286 2.463ZM47.341 405.597l-4.1 2.393-4.286-2.464 4.1-2.393 4.286 2.464ZM40.185 407.293l-4.1 2.393-4.287-2.463 4.1-2.39 4.287 2.46ZM71.876 408.068l-4.09 2.392-4.295-2.462 4.1-2.393 4.285 2.463ZM31.26 408.004l-4.1 2.394-6.7-3.849 4.094-2.394 6.706 3.849ZM52.167 408.364l-4.1 2.393-4.286-2.463 4.1-2.393 4.286 2.463ZM45.008 410.064l-4.094 2.394-4.294-2.463 4.1-2.393 4.288 2.462ZM76.983 411l-4.1 2.393-4.285-2.461 4.1-2.394L76.983 411ZM56.992 411.135l-4.1 2.395-4.289-2.46 4.1-2.393 4.29 2.458ZM70.06 412.834l-4.09 2.393-4.291-2.461 4.1-2.394 4.282 2.462ZM49.778 412.805l-4.1 2.393-4.285-2.461 4.1-2.393 4.285 2.461ZM82.09 413.933l-4.1 2.393-4.289-2.466 4.1-2.392 4.29 2.465ZM87.193 416.856l-4.1 2.393-4.29-2.466 4.1-2.393 4.29 2.466ZM61.813 413.908l-4.094 2.4-4.29-2.466 4.1-2.393 4.284 2.459ZM74.943 415.636l-4.1 2.394-4.286-2.461 4.094-2.4 4.292 2.467ZM54.765 415.668l-4.1 2.393-4.289-2.464 4.1-2.393 4.289 2.464ZM66.636 416.678l-4.094 2.394-4.29-2.465 4.1-2.392 4.284 2.463ZM59.536 418.408l-4.1 2.393-4.286-2.464 4.094-2.39 4.292 2.461ZM71.468 419.449l-4.1 2.392-4.293-2.462 4.1-2.394 4.293 2.464ZM82.18 419.791l-4.1 2.4-6.644-3.816 4.1-2.392 6.644 3.808ZM64.357 421.177l-4.1 2.393-4.29-2.463 4.1-2.393 4.29 2.463ZM43.533 421.023l-6.073 3.53-15.346-8.861 6.075-3.528 15.344 8.859ZM57.845 423.278l-4.1 2.39-6.7-3.845 4.1-2.394 6.7 3.849Z"
            fill="#F8F9FC"
        />
        <path
            d="m76.897 422.876-4.747 2.773-2.724 1.591-1.375.8-7.233-4.156 4.1-2.393 2.221 1.278 4.747-2.773 5.011 2.88Z"
            fill="#F8F9FC"
        />
        <path
            d="M91.891 415.213c1.463.844 1.471 2.223.017 3.068l-30.965 17.994a5.865 5.865 0 0 1-5.3 0L1.81 405.196c-1.462-.845-1.47-2.225-.015-3.072l30.963-17.992a5.84 5.84 0 0 1 5.3 0l53.833 31.081Zm-54.432 9.339 6.073-3.529-15.343-8.86-6.075 3.528 15.345 8.861Zm-9.688-13.8 18.837 10.82 4.1-2.393-18.845-10.82-4.093 2.393h.002Zm41.654 16.5 2.725-1.591 4.746-2.773-5.01-2.878-4.748 2.773-2.22-1.278-4.1 2.393 7.233 4.156 1.373-.8.001-.002Zm-28.862-31.354-10.557-6.064-4.1 2.395 10.562 6.065 4.092-2.4.002.004Zm-10.03 5.861-10.562-6.065-4.09 2.395 10.555 6.063 4.1-2.392-.004-.001Zm-19.693-.727 9.084 5.216 4.1-2.391-9.088-5.218-4.091 2.392-.005.001Zm43.335 24.887 8.84 5.079 4.094-2.391-8.843-5.082-4.093 2.394h.002Zm-21.322-28.64-7.865-4.516-4.1 2.394 7.863 4.516 4.1-2.395.002.001Zm-12.393 9.278 6.7 3.849 4.1-2.393-6.7-3.85-4.093 2.394h-.006Zm26.585 15.272 6.7 3.846 4.1-2.391-6.7-3.849-4.1 2.395v-.001Zm24.395-3.45 6.645 3.815 4.095-2.4-6.645-3.812-4.1 2.392.005.005Zm-8.36 1.002 4.294 2.461 4.1-2.391-4.294-2.465-4.1 2.395Zm-18.069-9.317-4.289-2.462-4.1 2.393 4.294 2.462 4.094-2.393h.002Zm16.662-7.862-4.293-2.462-4.1 2.391 4.29 2.462 4.1-2.395.003.004Zm-6.906 13.466-4.289-2.465-4.1 2.393 4.29 2.465 4.1-2.393Zm15.892-2.495-4.095 2.4 4.288 2.461 4.1-2.395-4.29-2.463-.004-.003Zm-24.3-19.766-4.3-2.467-4.091 2.393 4.285 2.463 4.1-2.393.005.004Zm-.1 5.751-4.1 2.395 4.294 2.461 4.09-2.393-4.285-2.462v-.001Zm-10.84 5.395-4.287-2.462-4.1 2.393 4.285 2.463 4.1-2.395.002.001Zm30.362 5.818-4.1 2.395 4.293 2.461 4.091-2.392-4.287-2.463.003-.001Zm-4.88-2.8-4.1 2.392 4.291 2.462 4.1-2.393-4.288-2.461H60.9Zm-4.882-2.8-4.1 2.39 4.292 2.466 4.093-2.4-4.288-2.46.004.004Zm31.18 12.1-4.285-2.463-4.1 2.393 4.288 2.466 4.093-2.4.005.004Zm-5.1-2.93-4.288-2.465-4.1 2.392 4.29 2.466 4.1-2.393H82.1Zm-52.78-13.947 4.287 2.46 4.1-2.392-4.289-2.462-4.1 2.395.002-.001Zm19.3 11.083 4.288 2.46 4.1-2.395-4.288-2.459-4.1 2.393v.001Zm-14.472-8.312 4.288 2.461 4.1-2.395-4.288-2.459-4.1 2.392v.001Zm19.3 11.082 4.288 2.465 4.093-2.4-4.285-2.462-4.1 2.393.004.004Zm18.445-5.77-4.285-2.463-4.1 2.393 4.294 2.461 4.09-2.391h.001Zm-13.62 8.538 4.29 2.466 4.094-2.395-4.287-2.462-4.1 2.391h.003ZM51.46 396.34l-4.294-2.466-4.093 2.395 4.288 2.461 4.1-2.39h-.002Zm-12.5 9.183 4.285 2.465 4.1-2.393-4.284-2.465-4.1 2.393h-.002Zm4.825 2.771 4.285 2.463 4.1-2.393-4.285-2.463-4.1 2.393Zm1.878-9.478-4.288-2.461-4.1 2.392 4.286 2.462 4.1-2.393h.002Zm31.317 12.185-4.286-2.463-4.1 2.395 4.284 2.461 4.1-2.392.002-.001Zm-17.448 7.408-4.29-2.462-4.093 2.393 4.288 2.463 4.1-2.392-.005-.002Zm-8.4-16.445-4.1 2.393 4.285 2.462 4.1-2.393-4.288-2.462h.002Zm-1.352 10.84-4.285-2.461-4.1 2.393 4.285 2.461 4.1-2.393Zm14.58 8.374-4.288-2.463-4.1 2.393 4.288 2.462 4.1-2.392Zm-7.795-21.908-4.29-2.462-4.094 2.393 4.286 2.461 4.1-2.392h-.002Zm-21.544-12.372-4.1 2.393 4.289 2.461 4.093-2.391-4.285-2.463h.004Zm31.753 18.24-4.286-2.463-4.1 2.393 4.291 2.461 4.093-2.391h.002Zm-26.595 2.156-4.288-2.461-4.1 2.391 4.288 2.462 4.1-2.392Z"
            fill="#4361EE"
        />
        <path
            d="m39.305 389.361-4.094 2.39-4.29-2.46 4.1-2.394 4.284 2.464ZM45.661 398.816l-4.1 2.393-4.286-2.461 4.1-2.393 4.286 2.461ZM66.773 405.138l-4.094 2.392-4.29-2.462 4.1-2.393 4.284 2.463ZM60.302 407.227l-4.094 2.399-4.29-2.465 4.1-2.39 4.284 2.456ZM65.184 410.03l-4.1 2.393-4.29-2.462 4.1-2.393 4.29 2.462ZM50.71 419.175l-4.1 2.393-18.838-10.82 4.09-2.393 18.848 10.82ZM67.109 428.599l-4.094 2.392-8.841-5.079 4.093-2.394 8.842 5.081Z"
            fill="#F8F9FC"
        />
        <path
            d="M94.942 372.15 41.11 341.069a1.871 1.871 0 0 0-1.89-.182l-2.655 1.542a1.876 1.876 0 0 1 1.892.183l2.8 1.618a.665.665 0 0 0-.215.082c-.473.272-1.034.6-1.58.918-.358.208-.718.414-1.076.625a1.115 1.115 0 0 0-.466 1.024l-.095 32.792a3.505 3.505 0 0 0 1.588 2.751c.422-.242.838-.486 1.257-.73l-1.257.73 51.69 29.844a1.135 1.135 0 0 0 1.139.107l2.6-1.513-.01 3.235a1.865 1.865 0 0 1-.78 1.7c.441-.256.884-.514 1.326-.769.442-.255.885-.514 1.326-.773a1.856 1.856 0 0 0 .78-1.7l.1-35.815a5.863 5.863 0 0 0-2.642-4.588Z"
            fill="#331083"
        />
        <path
            d="m91.205 375.805-51.689-29.844c-.88-.507-1.6-.091-1.6.916l-.095 32.792a3.508 3.508 0 0 0 1.588 2.751l51.69 29.844c.877.506 1.6.1 1.6-.909l.093-32.795a3.532 3.532 0 0 0-1.587-2.755Z"
            fill="#E8ECEF"
        />
        <path
            d="m92.288 373.694-53.831-31.081c-1.465-.846-2.663-.161-2.669 1.518l-.1 35.814a5.865 5.865 0 0 0 2.648 4.6l53.834 31.078c1.462.843 2.662.155 2.668-1.526l.1-35.813a5.846 5.846 0 0 0-2.65-4.59Zm.42 37.662c.017.312-.082.62-.278.865a1.021 1.021 0 0 1-1.326.044l-36.331-20.977-15.359-8.865c-.02-.01-.038-.026-.058-.037a2.369 2.369 0 0 1-.17-.119 2.746 2.746 0 0 1-.242-.2 3.578 3.578 0 0 1-.654-.834 3.243 3.243 0 0 1-.462-1.562l.094-32.792c0-.064 0-.125.009-.183a1.39 1.39 0 0 1 .118-.456.91.91 0 0 1 .172-.251c.023-.023.044-.046.069-.067.025-.021.032-.024.049-.036a.799.799 0 0 1 .355-.133 1.101 1.101 0 0 1 .505.062l.079.029c.083.034.164.074.242.119l51.69 29.844a3.52 3.52 0 0 1 1.592 2.755l-.095 32.794Z"
            fill="#3F37C9"
        />
        <path
            d="M60.871 377.921a1.414 1.414 0 0 0-1.406-.143c-.777.443-.78 1.888-.009 3.226a4.034 4.034 0 0 0 1.4 1.478 1.411 1.411 0 0 0 1.405.143c.777-.443.782-1.888.01-3.226a4.035 4.035 0 0 0-1.4-1.478Z"
            fill="#F72585"
        />
        <path
            d="M56.235 375.649a.963.963 0 0 0-.956-.101c-.529.3-.53 1.284-.006 2.194.226.412.555.758.953 1.006a.963.963 0 0 0 .956.1c.53-.3.532-1.284.006-2.194a2.744 2.744 0 0 0-.953-1.005ZM51.733 373.16a.606.606 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.258.35.476.6.633a.615.615 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.724 1.724 0 0 0-.6-.633ZM74.733 387.16a.606.606 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.258.35.476.6.633a.615.615 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.724 1.724 0 0 0-.6-.633ZM71.235 384.386a.957.957 0 0 0-.956-.1c-.529.3-.53 1.284-.006 2.194.227.411.555.757.953 1.005a.967.967 0 0 0 .956.1c.53-.3.532-1.284.006-2.194a2.744 2.744 0 0 0-.953-1.005ZM60.871 371.921a1.414 1.414 0 0 0-1.406-.143c-.777.443-.78 1.888-.009 3.226a4.034 4.034 0 0 0 1.4 1.478 1.411 1.411 0 0 0 1.405.143c.777-.443.782-1.888.01-3.226a4.035 4.035 0 0 0-1.4-1.478ZM56.235 369.386a.957.957 0 0 0-.956-.1c-.529.3-.53 1.284-.006 2.194.226.411.555.757.953 1.005a.967.967 0 0 0 .956.1c.53-.3.532-1.284.006-2.194a2.744 2.744 0 0 0-.953-1.005ZM51.733 366.895a.615.615 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.477.6.633a.606.606 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.74 1.74 0 0 0-.6-.633ZM74.733 380.895a.615.615 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.477.6.633a.606.606 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.74 1.74 0 0 0-.6-.633ZM66.233 365.054a.606.606 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.476.6.633a.615.615 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.724 1.724 0 0 0-.6-.633ZM66.233 393.054a.606.606 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.476.6.633a.615.615 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.724 1.724 0 0 0-.6-.633ZM61.233 362.054a.606.606 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.476.6.633a.615.615 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.724 1.724 0 0 0-.6-.633ZM61.233 390.054a.606.606 0 0 0-.6-.061c-.333.19-.335.809 0 1.381.143.259.35.476.6.633a.615.615 0 0 0 .6.061c.333-.19.335-.808 0-1.381a1.724 1.724 0 0 0-.6-.633ZM56.235 363.386a.957.957 0 0 0-.956-.1c-.529.3-.53 1.284-.006 2.194.226.411.555.757.953 1.005a.967.967 0 0 0 .956.1c.53-.3.532-1.284.006-2.194a2.744 2.744 0 0 0-.953-1.005ZM71.235 378.386a.957.957 0 0 0-.956-.1c-.529.3-.53 1.284-.006 2.194.227.411.555.757.953 1.005a.967.967 0 0 0 .956.1c.53-.3.532-1.284.006-2.194a2.744 2.744 0 0 0-.953-1.005ZM61.235 366.386a.957.957 0 0 0-.956-.1c-.529.3-.53 1.284-.006 2.194.226.411.555.757.953 1.005a.967.967 0 0 0 .956.1c.53-.3.532-1.284.006-2.194a2.744 2.744 0 0 0-.953-1.005ZM71.235 372.386a.957.957 0 0 0-.956-.1c-.529.3-.53 1.284-.006 2.194.227.411.555.757.953 1.005a.967.967 0 0 0 .956.1c.53-.3.532-1.284.006-2.194a2.744 2.744 0 0 0-.953-1.005ZM61.235 384.833a.957.957 0 0 0-.956-.1c-.529.3-.53 1.284-.006 2.194.226.411.555.757.953 1.005a.967.967 0 0 0 .956.1c.53-.3.532-1.284.006-2.194a2.744 2.744 0 0 0-.953-1.005ZM56.235 382.386a.957.957 0 0 0-.956-.1c-.529.3-.53 1.284-.006 2.194.226.411.555.757.953 1.005a.967.967 0 0 0 .956.1c.53-.3.532-1.284.006-2.194a2.744 2.744 0 0 0-.953-1.005ZM71.235 390.386a.957.957 0 0 0-.956-.1c-.529.3-.53 1.284-.006 2.194.227.411.555.757.953 1.005a.967.967 0 0 0 .956.1c.53-.3.532-1.284.006-2.194a2.744 2.744 0 0 0-.953-1.005ZM65.871 380.921a1.414 1.414 0 0 0-1.406-.143c-.777.443-.78 1.888-.009 3.226a4.034 4.034 0 0 0 1.4 1.478 1.411 1.411 0 0 0 1.405.143c.777-.443.782-1.888.01-3.226a4.035 4.035 0 0 0-1.4-1.478Z"
            fill="#7209B7"
        />
        <path
            d="M65.871 374.921a1.414 1.414 0 0 0-1.406-.143c-.777.443-.78 1.888-.009 3.226a4.034 4.034 0 0 0 1.4 1.478 1.411 1.411 0 0 0 1.405.143c.777-.443.782-1.888.01-3.226a4.035 4.035 0 0 0-1.4-1.478Z"
            fill="#F72585"
        />
        <path
            d="M66.235 369.386a.957.957 0 0 0-.956-.1c-.529.3-.53 1.284-.006 2.194.227.411.555.757.953 1.005a.967.967 0 0 0 .956.1c.53-.3.532-1.284.006-2.194a2.744 2.744 0 0 0-.953-1.005ZM66.235 387.833a.957.957 0 0 0-.956-.1c-.529.3-.53 1.284-.006 2.194.227.411.555.757.953 1.005a.967.967 0 0 0 .956.1c.53-.3.532-1.284.006-2.194a2.744 2.744 0 0 0-.953-1.005Z"
            fill="#7209B7"
        />
        <path
            d="m220.276 89.455 80.511-46.428a17.395 17.395 0 0 1 15.723.001l80.511 46.429c4.342 2.503 4.341 6.562 0 9.066l-80.511 46.429a17.388 17.388 0 0 1-15.722-.003L220.276 98.52c-4.342-2.503-4.342-6.562 0-9.065Z"
            fill="#282739"
        />
        <path
            d="M378.395 76.495h-43.44l-26.4 34.619h69.839l30.2-17.31-30.199-17.31ZM304.998 65.677h-25.731l-8.178 4.688-.662-.7-2.916 1.677 2.9 1.662h1.921l6.935 3.976h25.736l9.859-5.651-9.864-5.652Z"
            fill="#101015"
        />
        <path
            d="M290.376 74.06H264.64l-8.178 4.688-.662-.7-2.916 1.676 2.9 1.661h1.921l6.935 3.977h25.736l9.859-5.652-9.859-5.65Z"
            fill="#101015"
        />
        <path
            d="M275.707 82.434h-25.736l-8.178 4.688-.662-.7-2.916 1.676 2.9 1.662h1.921l6.935 3.976h25.736l9.858-5.651-9.858-5.651Z"
            fill="#101015"
        />
        <path
            d="M292.545 92.28h-25.736l-8.177 4.689-.662-.7-2.916 1.676 2.9 1.663h1.921l6.935 3.976h25.736l9.859-5.651-9.86-5.652Z"
            fill="#101015"
        />
        <path
            d="M219.208 91.495c-.891.89-1.293 1.876-1.164 2.851.159 1.21 1.129 2.385 2.732 3.308l80.512 46.428c1.951 1.125 4.565 1.744 7.362 1.744 2.797 0 5.411-.619 7.361-1.744l80.513-46.427a7.538 7.538 0 0 0 1.568-1.174c.89-.89 1.293-1.877 1.164-2.852-.16-1.21-1.13-2.384-2.732-3.308l-80.513-46.428c-1.95-1.124-4.564-1.744-7.361-1.744-2.797 0-5.411.62-7.362 1.744l-80.512 46.428a7.511 7.511 0 0 0-1.568 1.174Zm-.707-.707a8.485 8.485 0 0 1 1.775-1.333l80.513-46.428c4.341-2.503 11.38-2.503 15.722 0l80.512 46.428c4.342 2.503 4.342 6.562 0 9.066l-80.512 46.428c-4.342 2.503-11.381 2.503-15.722 0l-80.513-46.428c-3.634-2.096-4.226-5.282-1.775-7.733Z"
            fill="#DEDDE2"
        />
        <path
            d="M334.302 48.919h-25.734l-8.178 4.687-.662-.7-2.916 1.678 2.9 1.662h1.921l6.935 3.975h25.734l9.859-5.651-9.859-5.651Z"
            fill="#93A865"
        />
        <path
            d="M302.585 54.581v-5.028l-2.9 1.662v5.029l2.9-1.663Z"
            fill="#A67C52"
        />
        <path
            d="M296.784 54.581v-5.028l2.9 1.662v5.029l-2.9-1.663Z"
            fill="#C69C6D"
        />
        <path
            d="m299.683 47.89-2.9 1.663 2.9 1.663 2.9-1.663-2.9-1.662Z"
            fill="#F2F2F2"
        />
        <path
            d="M309.544 45.897v-7.173l-9.859 5.652v7.173l9.859-5.652Z"
            fill="#75934C"
        />
        <path
            d="M289.825 45.897v-7.173l9.858 5.652v7.173l-9.858-5.652Z"
            fill="#AAD86F"
        />
        <path
            d="m299.683 33.073-9.858 5.65 9.858 5.653 9.859-5.652-9.859-5.651Z"
            fill="#75934C"
        />
        <path
            d="M309.544 36.513V29.34l-9.859 5.652v7.173l9.859-5.652Z"
            fill="#75934C"
        />
        <path
            d="M289.825 36.513V29.34l9.858 5.652v7.173l-9.858-5.652Z"
            fill="#AAD86F"
        />
        <path
            d="m299.683 23.688-9.858 5.651 9.858 5.652 9.859-5.652-9.859-5.651Z"
            fill="#75934C"
        />
        <path
            d="M309.544 27.122v-7.173l-9.859 5.65v7.174l9.859-5.651Z"
            fill="#75934C"
        />
        <path
            d="M289.825 27.122v-7.173l9.858 5.65v7.174l-9.858-5.651Z"
            fill="#AAD86F"
        />
        <path
            d="m299.683 14.302-9.858 5.652 9.858 5.652 9.859-5.652-9.859-5.652Z"
            fill="#C7F08F"
        />
        <path
            d="M273.306 71.339v-5.031l-2.9 1.662v5.029l2.9-1.66Z"
            fill="#A67C52"
        />
        <path
            d="M267.507 71.339v-5.031l2.9 1.662v5.029l-2.9-1.66Z"
            fill="#C69C6D"
        />
        <path
            d="m270.407 64.647-2.9 1.663 2.9 1.661 2.9-1.661-2.9-1.663Z"
            fill="#F2F2F2"
        />
        <path
            d="M280.265 62.653v-7.172l-9.859 5.65v7.173l9.859-5.65Z"
            fill="#75934C"
        />
        <path
            d="M260.548 62.653v-7.172l9.859 5.65v7.173l-9.859-5.65Z"
            fill="#AAD86F"
        />
        <path
            d="m270.407 49.83-9.859 5.651 9.859 5.652 9.859-5.652-9.859-5.651Z"
            fill="#75934C"
        />
        <path
            d="M280.265 53.27v-7.173l-9.859 5.65v7.174l9.859-5.651Z"
            fill="#75934C"
        />
        <path
            d="M260.548 53.27v-7.173l9.859 5.65v7.174l-9.859-5.651Z"
            fill="#AAD86F"
        />
        <path
            d="m270.407 40.445-9.859 5.652 9.859 5.65 9.859-5.65-9.859-5.652Z"
            fill="#75934C"
        />
        <path
            d="M280.265 43.883V36.71l-9.859 5.652v7.173l9.859-5.652Z"
            fill="#75934C"
        />
        <path
            d="M260.548 43.883V36.71l9.859 5.652v7.173l-9.859-5.652Z"
            fill="#AAD86F"
        />
        <path
            d="m270.407 31.059-9.859 5.65 9.859 5.652 9.859-5.651-9.859-5.651Z"
            fill="#C7F08F"
        />
        <path
            d="M258.636 79.718v-5.03l-2.9 1.663v5.029l2.9-1.662Z"
            fill="#A67C52"
        />
        <path
            d="M252.837 79.718v-5.03l2.9 1.663v5.029l-2.9-1.662Z"
            fill="#C69C6D"
        />
        <path
            d="m255.737 73.022-2.9 1.661 2.9 1.662 2.9-1.662-2.9-1.662Z"
            fill="#F2F2F2"
        />
        <path
            d="M265.595 71.028v-7.175l-9.859 5.652v7.172l9.859-5.65Z"
            fill="#75934C"
        />
        <path
            d="M245.878 71.028v-7.175l9.859 5.652v7.172l-9.859-5.65Z"
            fill="#AAD86F"
        />
        <path
            d="m255.736 58.204-9.859 5.65 9.859 5.652 9.859-5.651-9.859-5.651Z"
            fill="#75934C"
        />
        <path
            d="M265.595 61.643V54.47l-9.859 5.652v7.173l9.859-5.652Z"
            fill="#75934C"
        />
        <path
            d="M245.878 61.643V54.47l9.859 5.652v7.173l-9.859-5.652Z"
            fill="#AAD86F"
        />
        <path
            d="m255.736 48.819-9.859 5.651 9.859 5.652 9.859-5.652-9.859-5.651Z"
            fill="#75934C"
        />
        <path
            d="M265.595 52.258v-7.174l-9.859 5.653v7.173l9.859-5.652Z"
            fill="#75934C"
        />
        <path
            d="M245.878 52.258v-7.174l9.859 5.653v7.173l-9.859-5.652Z"
            fill="#AAD86F"
        />
        <path
            d="m255.736 39.433-9.859 5.652 9.859 5.652 9.859-5.652-9.859-5.652Z"
            fill="#C7F08F"
        />
        <path
            d="M244.014 88.097v-5.03l-2.9 1.663v5.029l2.9-1.662Z"
            fill="#A67C52"
        />
        <path
            d="M238.215 88.097v-5.03l2.9 1.663v5.029l-2.9-1.662Z"
            fill="#C69C6D"
        />
        <path
            d="m241.115 81.407-2.9 1.662 2.9 1.662 2.9-1.662-2.9-1.662Z"
            fill="#F2F2F2"
        />
        <path
            d="M250.973 79.415v-7.173l-9.859 5.652v7.173l9.859-5.652Z"
            fill="#75934C"
        />
        <path
            d="M231.256 79.415v-7.173l9.859 5.652v7.173l-9.859-5.652Z"
            fill="#AAD86F"
        />
        <path
            d="m241.115 66.59-9.859 5.65 9.859 5.653 9.859-5.652-9.859-5.651Z"
            fill="#75934C"
        />
        <path
            d="M250.973 70.029v-7.173l-9.859 5.652v7.173l9.859-5.652Z"
            fill="#75934C"
        />
        <path
            d="M231.256 70.029v-7.173l9.859 5.652v7.173l-9.859-5.652Z"
            fill="#AAD86F"
        />
        <path
            d="m241.115 57.2-9.859 5.653 9.859 5.652 9.859-5.652-9.859-5.652Z"
            fill="#75934C"
        />
        <path
            d="M250.973 60.643V53.47l-9.859 5.65v7.174l9.859-5.651Z"
            fill="#75934C"
        />
        <path
            d="M231.256 60.643V53.47l9.859 5.65v7.174l-9.859-5.651Z"
            fill="#AAD86F"
        />
        <path
            d="m241.115 47.818-9.859 5.652 9.859 5.65 9.859-5.65-9.859-5.652Z"
            fill="#C7F08F"
        />
        <path
            d="M260.851 97.944v-5.03l-2.9 1.663v5.029l2.9-1.662Z"
            fill="#A67C52"
        />
        <path
            d="M255.052 97.944v-5.03l2.9 1.663v5.029l-2.9-1.662Z"
            fill="#C69C6D"
        />
        <path
            d="m257.952 91.252-2.9 1.663 2.9 1.662 2.9-1.662-2.9-1.663Z"
            fill="#F2F2F2"
        />
        <path
            d="M267.81 89.258v-7.173l-9.859 5.651v7.173l9.859-5.65Z"
            fill="#75934C"
        />
        <path
            d="M248.093 89.258v-7.173l9.858 5.651v7.173l-9.858-5.65Z"
            fill="#AAD86F"
        />
        <path
            d="m257.952 76.435-9.858 5.652 9.858 5.65 9.859-5.65-9.859-5.652Z"
            fill="#75934C"
        />
        <path
            d="M267.81 79.874v-7.17l-9.859 5.653v7.173l9.859-5.656Z"
            fill="#75934C"
        />
        <path
            d="M248.093 79.874v-7.17l9.858 5.653v7.173l-9.858-5.656Z"
            fill="#AAD86F"
        />
        <path
            d="m257.952 67.05-9.858 5.652 9.858 5.652 9.859-5.652-9.859-5.652Z"
            fill="#75934C"
        />
        <path
            d="M267.81 70.487v-7.172l-9.859 5.65v7.173l9.859-5.65Z"
            fill="#75934C"
        />
        <path
            d="M248.093 70.487v-7.172l9.858 5.65v7.173l-9.858-5.65Z"
            fill="#AAD86F"
        />
        <path
            d="m257.952 57.664-9.858 5.65 9.858 5.652 9.859-5.651-9.859-5.651Z"
            fill="#C7F08F"
        />
        <path
            d="M332.312 69.675v-5.02l-2.895 1.66v5.02l2.895-1.66Z"
            fill="#A67C52"
        />
        <path
            d="M326.523 69.675v-5.02l2.895 1.66v5.02l-2.895-1.66Z"
            fill="#C69C6D"
        />
        <path
            d="m329.418 62.994-2.895 1.66 2.895 1.66 2.895-1.66-2.895-1.66Z"
            fill="#F2F2F2"
        />
        <path
            d="M339.26 61.005v-7.16l-9.842 5.642v7.16l9.842-5.642Z"
            fill="#75934C"
        />
        <path
            d="M319.575 61.005v-7.16l9.842 5.642v7.16l-9.842-5.642Z"
            fill="#AAD86F"
        />
        <path
            d="m329.419 48.2-9.842 5.643 9.842 5.642 9.843-5.642-9.843-5.642Z"
            fill="#75934C"
        />
        <path
            d="M339.26 51.634v-7.16l-9.842 5.641v7.161l9.842-5.642Z"
            fill="#75934C"
        />
        <path
            d="M319.575 51.634v-7.16l9.842 5.641v7.161l-9.842-5.642Z"
            fill="#AAD86F"
        />
        <path
            d="m329.419 38.83-9.842 5.642 9.842 5.642 9.843-5.642-9.843-5.642Z"
            fill="#75934C"
        />
        <path
            d="M339.26 42.263v-7.16l-9.842 5.64v7.162l9.842-5.642Z"
            fill="#75934C"
        />
        <path
            d="M319.575 42.263v-7.16l9.842 5.64v7.162l-9.842-5.642Z"
            fill="#AAD86F"
        />
        <path
            d="m329.419 29.46-9.842 5.642 9.842 5.642 9.843-5.642-9.843-5.642Z"
            fill="#C7F08F"
        />
        <path
            d="M349.123 79.504v-5.02l-2.895 1.658v5.021l2.895-1.659Z"
            fill="#A67C52"
        />
        <path
            d="M343.333 79.504v-5.02l2.895 1.658v5.021l-2.895-1.659Z"
            fill="#C69C6D"
        />
        <path
            d="m346.228 72.824-2.895 1.66 2.895 1.66 2.895-1.66-2.895-1.66Z"
            fill="#F2F2F2"
        />
        <path
            d="M356.07 70.835v-7.162l-9.842 5.642v7.162l9.842-5.642Z"
            fill="#75934C"
        />
        <path
            d="M336.385 70.835v-7.162l9.842 5.642v7.162l-9.842-5.642Z"
            fill="#AAD86F"
        />
        <path
            d="m346.227 58.03-9.842 5.643 9.842 5.642 9.843-5.642-9.843-5.642Z"
            fill="#75934C"
        />
        <path
            d="M356.07 61.463v-7.162l-9.842 5.643v7.161l9.842-5.642Z"
            fill="#75934C"
        />
        <path
            d="M336.385 61.463v-7.162l9.842 5.643v7.161l-9.842-5.642Z"
            fill="#AAD86F"
        />
        <path
            d="m346.227 48.66-9.842 5.642 9.842 5.642 9.843-5.642-9.843-5.642Z"
            fill="#75934C"
        />
        <path
            d="M356.07 52.093v-7.164l-9.842 5.642v7.16l9.842-5.638Z"
            fill="#75934C"
        />
        <path
            d="M336.385 52.093v-7.164l9.842 5.642v7.16l-9.842-5.638Z"
            fill="#AAD86F"
        />
        <path
            d="m346.227 39.29-9.842 5.642 9.842 5.642 9.843-5.642-9.843-5.642Z"
            fill="#C7F08F"
        />
        <path
            d="M364.348 86.892V81.87l-2.895 1.66v5.02l2.895-1.66Z"
            fill="#A67C52"
        />
        <path
            d="M358.559 86.892V81.87l2.894 1.66v5.02l-2.894-1.66Z"
            fill="#C69C6D"
        />
        <path
            d="m361.45 80.211-2.895 1.66 2.895 1.66 2.895-1.66-2.895-1.66Z"
            fill="#F2F2F2"
        />
        <path
            d="M371.295 78.222v-7.161l-9.843 5.643v7.161l9.843-5.643Z"
            fill="#75934C"
        />
        <path
            d="M351.61 78.222v-7.161l9.843 5.642v7.161l-9.843-5.642Z"
            fill="#AAD86F"
        />
        <path
            d="m361.453 65.419-9.843 5.642 9.843 5.642 9.842-5.642-9.842-5.642Z"
            fill="#75934C"
        />
        <path
            d="M371.295 68.85v-7.16l-9.842 5.642v7.16l9.842-5.641Z"
            fill="#75934C"
        />
        <path
            d="M351.61 68.85v-7.16l9.843 5.642v7.16l-9.843-5.641Z"
            fill="#AAD86F"
        />
        <path
            d="m361.453 56.048-9.843 5.642 9.843 5.642 9.842-5.642-9.842-5.642Z"
            fill="#75934C"
        />
        <path
            d="M371.295 59.478v-7.161l-9.842 5.642v7.16l9.842-5.641Z"
            fill="#75934C"
        />
        <path
            d="M351.61 59.478v-7.161l9.843 5.642v7.16l-9.843-5.641Z"
            fill="#AAD86F"
        />
        <path
            d="m361.453 46.678-9.843 5.642 9.843 5.642 9.842-5.642-9.842-5.642Z"
            fill="#C7F08F"
        />
        <path
            d="M381.158 96.722V91.7l-2.895 1.66v5.02l2.895-1.66Z"
            fill="#A67C52"
        />
        <path
            d="M375.368 96.722V91.7l2.895 1.66v5.02l-2.895-1.66Z"
            fill="#C69C6D"
        />
        <path
            d="m378.263 90.041-2.895 1.66 2.895 1.66 2.895-1.66-2.895-1.66Z"
            fill="#F2F2F2"
        />
        <path
            d="M388.105 88.053v-7.162l-9.842 5.643v7.161l9.842-5.642Z"
            fill="#75934C"
        />
        <path
            d="M368.42 88.053v-7.162l9.842 5.643v7.161l-9.842-5.642Z"
            fill="#AAD86F"
        />
        <path
            d="m378.263 75.249-9.842 5.642 9.842 5.642 9.842-5.642-9.842-5.642Z"
            fill="#75934C"
        />
        <path
            d="M388.105 78.68v-7.16l-9.842 5.642v7.161l9.842-5.642Z"
            fill="#75934C"
        />
        <path
            d="M368.42 78.68v-7.16l9.842 5.642v7.161l-9.842-5.642Z"
            fill="#AAD86F"
        />
        <path
            d="m378.263 65.878-9.842 5.642 9.842 5.642 9.842-5.642-9.842-5.642Z"
            fill="#75934C"
        />
        <path
            d="M388.105 69.31v-7.16l-9.842 5.642v7.16l9.842-5.641Z"
            fill="#75934C"
        />
        <path
            d="M368.42 69.31v-7.16l9.842 5.642v7.16l-9.842-5.641Z"
            fill="#AAD86F"
        />
        <path
            d="m378.263 56.508-9.842 5.642 9.842 5.642 9.842-5.642-9.842-5.642Z"
            fill="#C7F08F"
        />
        <path d="M278.359 93.844v-35l30.2 17.31v35l-30.2-17.31Z" fill="#DEDDE2" />
        <path d="M338.751 93.844v-35l-30.2 17.31v35l30.2-17.31Z" fill="#ADABB9" />
        <path
            d="m308.555 41.537-30.201 17.31 30.201 17.31 30.2-17.31-30.2-17.31Z"
            fill="#E3DAD7"
        />
        <path d="M278.359 58.963v-35l30.2 17.31v35l-30.2-17.31Z" fill="#DEDDE2" />
        <path d="M338.751 58.963v-35l-30.2 17.31v35l30.2-17.31Z" fill="#ADABB9" />
        <path
            d="m308.555 6.656-30.201 17.31 30.201 17.31 30.2-17.31-30.2-17.31Z"
            fill="#D7D6DD"
        />
        <path
            d="M320.836 48.728v-6.034l7.339-4.238v6.036l5.786-3.341v7.228l-5.786 3.34v6.091l-7.339 4.238v-6.092l-5.786 3.342V52.07l5.786-3.342ZM296.785 48.728v-6.034l-7.339-4.238v6.036l-5.786-3.341v7.228l5.786 3.34v6.091l7.339 4.238v-6.092l5.786 3.342V52.07l-5.786-3.342Z"
            fill="#4361EE"
        />
        <path
            d="m304.224 74.302-21.61-12.3.009 28.591 21.6 12.293.001-28.584Z"
            fill="#ADABB9"
        />
        <path
            d="m283.605 90.06 20.619 11.729V74.302l-20.627-11.734.008 27.492Z"
            fill="#FAF8F8"
        />
        <path
            d="m313.116 74.302 21.61-12.3-.009 28.591-21.6 12.293-.001-28.584Z"
            fill="#888595"
        />
        <path
            d="m333.735 90.06-20.619 11.729V74.302l20.627-11.734-.008 27.492Z"
            fill="#E9E5F2"
        />
        <path
            d="m308.554 6.656-30.195 17.31 30.195 17.31 30.2-17.31-30.2-17.31Zm-23.581 17.31 23.581-13.52 23.582 13.52-23.582 13.518-23.581-13.518Z"
            fill="#F4EFED"
        />
        <path
            d="m456.193 89.558 62.985-36.32a13.608 13.608 0 0 1 12.304 0l62.979 36.32c3.396 1.958 3.396 5.135 0 7.093l-62.982 36.317a13.596 13.596 0 0 1-12.303 0l-62.983-36.317c-3.397-1.96-3.397-5.134 0-7.093Z"
            fill="#282739"
        />
        <path
            d="M579.888 79.42h-33.983l-20.651 27.083h54.635l23.622-13.54-23.623-13.543ZM522.47 70.957h-20.133l-6.4 3.668-.518-.547-2.281 1.311 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.42-7.706-4.422Z"
            fill="#101015"
        />
        <path
            d="M511.031 77.515h-20.132l-6.4 3.667-.518-.547-2.281 1.311 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.42-7.707-4.421Z"
            fill="#101015"
        />
        <path
            d="M499.557 84.065h-20.133l-6.4 3.667-.518-.546-2.281 1.31 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.42-7.706-4.42Z"
            fill="#101015"
        />
        <path
            d="M512.728 91.77h-20.133l-6.4 3.666-.518-.547-2.281 1.311 2.268 1.3h1.5l5.425 3.111h20.132l7.713-4.422-7.706-4.42Z"
            fill="#101015"
        />
        <path
            d="M455.511 91.308c-.451.451-.964 1.173-.849 2.048.116.878.837 1.74 2.03 2.428l62.985 36.321c1.493.861 3.5 1.335 5.65 1.335 2.151 0 4.157-.474 5.65-1.335l62.985-36.32a5.67 5.67 0 0 0 1.181-.885c.451-.45.965-1.172.849-2.047-.116-.878-.837-1.74-2.03-2.428l-62.985-36.32c-1.493-.861-3.499-1.336-5.65-1.336-2.15 0-4.157.474-5.65 1.336l-62.985 36.32a5.7 5.7 0 0 0-1.181.883Zm-.707-.707a6.662 6.662 0 0 1 1.389-1.043l62.985-36.32c3.396-1.958 8.902-1.958 12.299 0l62.984 36.32c3.397 1.959 3.397 5.134 0 7.093l-62.984 36.32c-3.397 1.958-8.903 1.958-12.299 0l-62.985-36.32c-2.843-1.64-3.306-4.132-1.389-6.05Z"
            fill="#DEDDE2"
        />
        <path
            d="M545.397 57.849h-20.134l-6.4 3.667-.518-.547-2.281 1.312 2.268 1.3h1.5l5.425 3.11h20.133l7.712-4.421-7.705-4.421Z"
            fill="#93A865"
        />
        <path
            d="M520.581 62.28v-3.934l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M516.046 62.28v-3.934l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m518.314 57.045-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M526.025 55.48V49.87l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M510.602 55.48V49.87l7.712 4.42v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m518.314 45.453-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M526.025 48.142V42.53l-7.712 4.421v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M510.602 48.142V42.53l7.712 4.421v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m518.314 38.11-7.712 4.42 7.712 4.421 7.712-4.42-7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M526.025 40.8v-5.61l-7.712 4.42v5.611l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M510.602 40.8v-5.61l7.712 4.42v5.611l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m518.314 30.768-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M497.68 75.387v-3.936l-2.268 1.3v3.934l2.268-1.298Z"
            fill="#A67C52"
        />
        <path
            d="M493.143 75.387v-3.936l2.268 1.3v3.934l-2.268-1.298Z"
            fill="#C69C6D"
        />
        <path
            d="m495.412 70.153-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M503.123 68.594v-5.61l-7.712 4.42v5.611l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M487.698 68.594v-5.61l7.712 4.42v5.611l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m495.411 58.562-7.712 4.42 7.712 4.422 7.712-4.422-7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M503.123 61.25v-5.61l-7.712 4.42v5.612l7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M487.698 61.25v-5.61l7.712 4.42v5.612l-7.712-4.422Z"
            fill="#AAD86F"
        />
        <path
            d="m495.411 51.218-7.712 4.421 7.712 4.421 7.712-4.42-7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M503.123 53.91v-5.613l-7.712 4.421v5.611l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M487.698 53.91v-5.613l7.712 4.421v5.611l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m495.411 43.877-7.712 4.42 7.712 4.422 7.712-4.422-7.712-4.42Z"
            fill="#C7F08F"
        />
        <path
            d="M486.204 81.939v-3.934l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M481.667 81.939v-3.934l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m483.938 76.705-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M491.648 75.146v-5.613l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M476.223 75.146v-5.613l7.712 4.42v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m483.935 65.113-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M491.648 67.802V62.19l-7.712 4.422v5.61l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M476.223 67.802V62.19l7.712 4.422v5.61l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m483.935 57.77-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M491.648 60.46v-5.612l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M476.223 60.46v-5.612l7.712 4.42v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m483.935 50.428-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path
            d="M474.764 88.499v-3.934l-2.268 1.3v3.934l2.268-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M470.228 88.499v-3.934l2.268 1.3v3.934l-2.268-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m472.497 83.264-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M480.208 81.71v-5.612l-7.712 4.42v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M464.783 81.71v-5.612l7.712 4.42v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m472.496 71.672-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M480.208 74.36v-5.61l-7.712 4.42v5.612l7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M464.783 74.36v-5.61l7.712 4.42v5.612l-7.712-4.421Z"
            fill="#AAD86F"
        />
        <path
            d="m472.496 64.326-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.421Z"
            fill="#75934C"
        />
        <path
            d="M480.208 67.02v-5.612l-7.712 4.42v5.613l7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M464.783 67.02v-5.612l7.712 4.42v5.613l-7.712-4.422Z"
            fill="#AAD86F"
        />
        <path
            d="m472.496 56.987-7.712 4.42 7.712 4.422 7.712-4.421-7.712-4.421Z"
            fill="#C7F08F"
        />
        <path d="M487.936 96.2v-3.934l-2.268 1.3V97.5l2.268-1.3Z" fill="#A67C52" />
        <path d="M483.399 96.2v-3.934l2.268 1.3V97.5l-2.268-1.3Z" fill="#C69C6D" />
        <path
            d="m485.667 90.966-2.268 1.3 2.268 1.3 2.268-1.3-2.268-1.3Z"
            fill="#F2F2F2"
        />
        <path
            d="M493.38 89.407v-5.612l-7.712 4.421v5.612l7.712-4.42Z"
            fill="#75934C"
        />
        <path
            d="M477.955 89.407v-5.612l7.712 4.421v5.612l-7.712-4.42Z"
            fill="#AAD86F"
        />
        <path
            d="m485.67 79.374-7.712 4.422 7.712 4.42 7.712-4.42-7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M493.38 82.064v-5.608l-7.712 4.421v5.611l7.712-4.424Z"
            fill="#75934C"
        />
        <path
            d="M477.955 82.064v-5.608l7.712 4.421v5.611l-7.712-4.424Z"
            fill="#AAD86F"
        />
        <path
            d="m485.67 72.031-7.712 4.421 7.712 4.421 7.712-4.42-7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M493.38 74.722v-5.61l-7.712 4.42v5.612l7.712-4.422Z"
            fill="#75934C"
        />
        <path
            d="M477.955 74.722v-5.61l7.712 4.42v5.612l-7.712-4.422Z"
            fill="#AAD86F"
        />
        <path
            d="m485.67 64.69-7.712 4.42 7.712 4.421 7.712-4.42-7.712-4.422Z"
            fill="#C7F08F"
        />
        <path
            d="M543.838 74.084v-3.928l-2.265 1.3v3.928l2.265-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M539.31 74.084v-3.928l2.265 1.3v3.928l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m541.574 68.858-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M549.274 67.302v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M533.875 67.302v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m541.574 57.286-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M549.274 59.97v-5.6l-7.7 4.414v5.6l7.7-4.413Z" fill="#75934C" />
        <path d="M533.875 59.97v-5.6l7.7 4.414v5.6l-7.7-4.413Z" fill="#AAD86F" />
        <path
            d="m541.574 49.955-7.7 4.414 7.7 4.413 7.7-4.413-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M549.274 52.64v-5.6l-7.7 4.415v5.6l7.7-4.415Z" fill="#75934C" />
        <path d="M533.875 52.64v-5.6l7.7 4.415v5.6l-7.7-4.415Z" fill="#AAD86F" />
        <path
            d="m541.574 42.624-7.7 4.415 7.7 4.414 7.7-4.414-7.7-4.415Z"
            fill="#C7F08F"
        />
        <path
            d="M556.989 81.775v-3.928l-2.265 1.3v3.927l2.265-1.299Z"
            fill="#A67C52"
        />
        <path
            d="M552.46 81.775v-3.928l2.265 1.3v3.927l-2.265-1.299Z"
            fill="#C69C6D"
        />
        <path
            d="m554.723 76.548-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M562.425 74.993v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M547.025 74.993v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m554.724 64.976-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M562.425 67.66v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M547.025 67.66v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m554.724 57.645-7.7 4.414 7.7 4.413 7.7-4.413-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M562.425 60.326v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M547.025 60.326v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m554.724 50.315-7.7 4.413 7.7 4.415 7.7-4.415-7.7-4.413Z"
            fill="#C7F08F"
        />
        <path
            d="M568.899 87.554v-3.927l-2.265 1.3v3.927l2.265-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M564.37 87.554v-3.927l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m566.634 82.329-2.265 1.3 2.265 1.3 2.264-1.3-2.264-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M574.335 80.772v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M558.936 80.772v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m566.636 70.756-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M574.335 73.44v-5.6l-7.7 4.415v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M558.936 73.44v-5.6l7.7 4.415v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m566.636 63.425-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M574.335 66.11v-5.6l-7.7 4.415v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M558.936 66.11v-5.6l7.7 4.415v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m566.636 56.095-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M582.049 95.243v-3.927l-2.265 1.3v3.927l2.265-1.3Z"
            fill="#A67C52"
        />
        <path
            d="M577.521 95.243v-3.927l2.265 1.3v3.927l-2.265-1.3Z"
            fill="#C69C6D"
        />
        <path
            d="m579.786 90.019-2.265 1.3 2.265 1.3 2.265-1.3-2.265-1.3Z"
            fill="#F2F2F2"
        />
        <path d="M587.485 88.462v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M572.086 88.462v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m579.786 78.446-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M587.485 81.13v-5.6l-7.7 4.414v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M572.086 81.13v-5.6l7.7 4.414v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m579.786 71.115-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#75934C"
        />
        <path d="M587.485 73.8v-5.6l-7.7 4.415v5.6l7.7-4.414Z" fill="#75934C" />
        <path d="M572.086 73.8v-5.6l7.7 4.415v5.6l-7.7-4.414Z" fill="#AAD86F" />
        <path
            d="m579.786 63.785-7.7 4.414 7.7 4.414 7.7-4.414-7.7-4.414Z"
            fill="#C7F08F"
        />
        <path
            d="M501.632 92.993V65.615l23.622 13.542v27.378l-23.622-13.542Z"
            fill="#DEDDE2"
        />
        <path
            d="M548.875 92.993V65.615l-23.622 13.542v27.378l23.622-13.542Z"
            fill="#ADABB9"
        />
        <path
            d="m525.253 52.073-23.622 13.542 23.622 13.54 23.622-13.54-23.622-13.542Z"
            fill="#E3DAD7"
        />
        <path
            d="M501.632 65.705V38.327l23.622 13.54v27.379l-23.622-13.541Z"
            fill="#DEDDE2"
        />
        <path
            d="M548.875 65.705V38.327l-23.622 13.54v27.379l23.622-13.541Z"
            fill="#ADABB9"
        />
        <path
            d="m525.253 24.786-23.622 13.54 23.622 13.543 23.622-13.542-23.622-13.541Z"
            fill="#D7D6DD"
        />
        <path
            d="M534.861 57.7v-4.721l5.741-3.315v4.72l4.526-2.613v5.655l-4.526 2.614v4.765l-5.741 3.315v-4.765l-4.527 2.614v-5.654l4.527-2.615ZM516.047 57.7v-4.721l-5.741-3.315v4.72l-4.526-2.613v5.655l4.526 2.614v4.765l5.741 3.315v-4.765l4.527 2.614v-5.654l-4.527-2.615Z"
            fill="#4361EE"
        />
        <path
            d="m521.866 77.706-16.905-9.621.007 22.366 16.9 9.618-.002-22.363Z"
            fill="#ADABB9"
        />
        <path
            d="m505.735 90.032 16.13 9.177v-21.5l-16.136-9.18.006 21.504Z"
            fill="#FAF8F8"
        />
        <path
            d="m528.822 77.706 16.905-9.621-.007 22.366-16.9 9.618.002-22.363Z"
            fill="#888595"
        />
        <path
            d="m544.952 90.032-16.13 9.177v-21.5l16.136-9.18-.006 21.504Z"
            fill="#E9E5F2"
        />
        <path
            d="m525.253 24.786-23.621 13.54 23.621 13.542 23.622-13.541-23.622-13.541Zm-18.448 13.54 18.448-10.576 18.448 10.577-18.448 10.575-18.448-10.575Z"
            fill="#F4EFED"
        />
        <path
            d="m179.674 333.054-.017 6.3c-.007 2.593-1.711 5.181-5.111 7.157-6.851 3.982-17.99 3.982-24.886 0-3.466-2-5.2-4.628-5.189-7.253l.017-6.3c-.007 2.625 1.724 5.251 5.189 7.253 6.9 3.981 18.035 3.981 24.886 0 3.4-1.977 5.1-4.565 5.112-7.158l-.001.001Z"
            fill="#3F37C9"
        />
        <path
            d="M174.481 325.797c6.9 3.981 6.926 10.437.081 14.415-6.845 3.978-17.99 3.981-24.886 0-6.896-3.981-6.925-10.429-.075-14.412 6.85-3.983 17.99-3.981 24.88-.003Z"
            fill="#331083"
        />
        <path
            d="m179.674 325.242-.017 6.3c-.007 2.592-1.711 5.181-5.111 7.157-6.851 3.981-17.99 3.981-24.886 0-3.466-2-5.2-4.628-5.189-7.252l.017-6.3c-.007 2.624 1.724 5.251 5.189 7.252 6.9 3.981 18.035 3.981 24.886 0 3.4-1.976 5.1-4.565 5.112-7.157h-.001Z"
            fill="#3F37C9"
        />
        <path
            d="M174.481 317.985c6.9 3.981 6.926 10.437.081 14.414-6.845 3.977-17.99 3.981-24.886 0-6.896-3.981-6.925-10.429-.075-14.41s17.99-3.98 24.88-.004Z"
            fill="#331083"
        />
        <path
            d="m179.674 317.43-.017 6.3c-.007 2.592-1.711 5.181-5.111 7.157-6.851 3.982-17.99 3.982-24.886 0-3.466-2-5.2-4.63-5.189-7.253l.017-6.3c-.007 2.625 1.724 5.251 5.189 7.253 6.9 3.981 18.035 3.981 24.886 0 3.4-1.977 5.1-4.565 5.112-7.158l-.001.001Z"
            fill="#3F37C9"
        />
        <path
            d="M174.481 310.173c6.9 3.981 6.926 10.437.081 14.414-6.845 3.977-17.99 3.981-24.886 0-6.896-3.981-6.925-10.429-.075-14.412 6.85-3.983 17.99-3.979 24.88-.002Z"
            fill="#331083"
        />
        <path
            d="m179.674 309.618-.017 6.3c-.007 2.593-1.711 5.182-5.111 7.158-6.851 3.981-17.99 3.981-24.886 0-3.466-2-5.2-4.628-5.189-7.253l.017-6.3c-.007 2.624 1.724 5.251 5.189 7.252 6.9 3.981 18.035 3.981 24.886 0 3.4-1.976 5.1-4.565 5.112-7.157h-.001Z"
            fill="#3F37C9"
        />
        <path
            d="M174.481 302.36c6.9 3.981 6.926 10.437.081 14.414-6.845 3.977-17.99 3.981-24.886 0-6.896-3.981-6.925-10.429-.075-14.41s17.99-3.982 24.88-.004Z"
            fill="#331083"
        />
        <path
            d="m179.674 301.803-.017 6.301c-.007 2.592-1.711 5.18-5.111 7.156-6.851 3.981-17.99 3.981-24.886 0-3.466-2-5.2-4.628-5.189-7.252l.017-6.3c-.007 2.624 1.724 5.252 5.189 7.254 6.9 3.981 18.035 3.981 24.886 0 3.4-1.977 5.1-4.566 5.112-7.159h-.001Z"
            fill="#3F37C9"
        />
        <path
            d="M174.481 294.548c6.9 3.981 6.926 10.437.081 14.414-6.845 3.977-17.99 3.981-24.886 0-6.896-3.981-6.925-10.431-.075-14.412 6.85-3.981 17.99-3.979 24.88-.002Z"
            fill="#331083"
        />
        <path
            d="m179.674 293.993-.017 6.3c-.007 2.593-1.711 5.181-5.111 7.158-6.851 3.981-17.99 3.981-24.886 0-3.466-2-5.2-4.628-5.189-7.253l.017-6.3c-.007 2.624 1.724 5.251 5.189 7.252 6.9 3.981 18.035 3.981 24.886 0 3.4-1.976 5.1-4.565 5.112-7.157h-.001Z"
            fill="#3F37C9"
        />
        <path
            d="M174.481 286.735c6.9 3.981 6.926 10.437.081 14.414-6.845 3.977-17.99 3.981-24.886 0-6.896-3.981-6.925-10.429-.075-14.412 6.85-3.983 17.99-3.98 24.88-.002Z"
            fill="#331083"
        />
        <path
            d="m173.108 341.343-1.337-.777-.108-38.231 1.337.777.108 38.231Z"
            fill="#9CB5CC"
        />
        <path
            d="m173 303.113-1.337-.777 25.071-14.475 1.337.777L173 303.113Z"
            fill="#D7E7F7"
        />
        <path
            d="m198.071 288.638.108 38.231-25.071 14.475-.108-38.231 25.071-14.475Z"
            fill="#F8F9FC"
        />
        <path
            d="m175.953 343.24-1.337-.777-.108-38.231 1.337.777.108 38.231Z"
            fill="#9CB5CC"
        />
        <path
            d="m175.845 305.01-1.337-.777 25.071-14.475 1.337.777-25.071 14.475Z"
            fill="#D7E7F7"
        />
        <path
            d="m200.916 290.535.108 38.231-25.071 14.475-.108-38.231 25.071-14.475Z"
            fill="#F8F9FC"
        />
        <path
            d="m178.904 345.583-1.337-.777-.108-38.231 1.337.777.108 38.231Z"
            fill="#9CB5CC"
        />
        <path
            d="m178.796 307.353-1.337-.777 25.071-14.475 1.337.777-25.071 14.475Z"
            fill="#D7E7F7"
        />
        <path
            d="m203.867 292.878.108 38.231-25.071 14.475-.108-38.231 25.071-14.475Z"
            fill="#F8F9FC"
        />
        <path
            d="m202.339 313.534.007 2.3-21.895 12.636-.007-2.3 21.895-12.636ZM202.307 303.744l.006 2.3-21.892 12.639-.007-2.3 21.893-12.639Z"
            fill="#9CB5CC"
        />
        <path
            d="m195.202 302.939.007 2.3-14.8 8.545-.006-2.3 14.799-8.545Z"
            fill="#FA7564"
        />
        <path
            d="m202.323 308.641.006 2.3-21.893 12.638-.006-2.3 21.893-12.638ZM202.364 323.332l.006 2.3-21.892 12.639-.006-2.3 21.892-12.639ZM202.349 318.433l.007 2.3-21.892 12.639-.007-2.3 21.892-12.639Z"
            fill="#9CB5CC"
        />
        <path
            d="m112.157 367.046-.953-.426-.1-.048 2.561 1.479.1.048.953.426c.021 0 .042.005.059.016l-2.559-1.479a.116.116 0 0 0-.061-.016ZM109.338 374.242a.168.168 0 0 0-.028-.069.165.165 0 0 0-.054-.051l-2.561-1.479a.174.174 0 0 1 .082.12l.532 1.035a.147.147 0 0 0 .023.06.144.144 0 0 0 .045.047l2.561 1.479a.159.159 0 0 1-.069-.107l-.531-1.035Z"
            fill="#331083"
        />
        <path
            d="M112.485 361.967a.148.148 0 0 0-.109-.013.235.235 0 0 0-.081.031.367.367 0 0 0-.068.049l-.969.631.527-1a.644.644 0 0 1 .093-.158.526.526 0 0 1 .134-.119.294.294 0 0 1 .082-.033.147.147 0 0 1 .059 0l1.106.123a.128.128 0 0 1 .049.016l-2.561-1.479a.18.18 0 0 0-.048-.016l-1.107-.123a.142.142 0 0 0-.058 0 .246.246 0 0 0-.082.034.578.578 0 0 0-.229.275l-.834 1.588-.09.157-1.687-.974a.144.144 0 0 0-.109-.014.253.253 0 0 0-.076.031.302.302 0 0 0-.068.049l-1.247 1.07a.586.586 0 0 0-.064.068.521.521 0 0 0-.126.426l.085 1.41v.151c-.051.059-.1.119-.15.18-.22.271-.426.553-.617.846a.608.608 0 0 1-.127.1.404.404 0 0 1-.1.038.321.321 0 0 1-.062 0l-1.191.157a.186.186 0 0 0-.048.006.255.255 0 0 0-.089.035.622.622 0 0 0-.236.282l-.656 1.653c-.065.16-.045.3.04.352l1.08.624a7.174 7.174 0 0 0-.157 1 .797.797 0 0 1-.137.255.715.715 0 0 1-.086.088l-1.16 1.28a.386.386 0 0 0-.066.068.502.502 0 0 0-.124.416l.308 1.263a.153.153 0 0 0 .071.1l1.841 1.063-.147.537c-.065.16-.04.305.045.355l2.561 1.479c-.086-.049-.11-.2-.045-.355l.447-1.63a.47.47 0 0 0 .021-.351 2.273 2.273 0 0 1-.506-.587l-1.732-1 1.048-1.155a.715.715 0 0 0 .222-.344 7.75 7.75 0 0 1 .18-1.145l-1.168-.674a.419.419 0 0 1 .027-.157l.656-1.653a.568.568 0 0 1 .1-.163.471.471 0 0 1 .136-.119.255.255 0 0 1 .089-.035.186.186 0 0 1 .048-.006l1.191-.157c.02.002.041.002.062 0a.404.404 0 0 0 .1-.038.581.581 0 0 0 .126-.106c.2-.293.4-.576.618-.844.049-.061.1-.12.15-.18v-.151l-.085-1.41a.517.517 0 0 1 .126-.426.586.586 0 0 1 .064-.068l.79-.677 1.394.8a.184.184 0 0 0 .106.02c.281-.133.576-.233.88-.3h.016l.092-.16.1-.184 2.339 1.35.13-.076 1.271-.827a.367.367 0 0 1 .149-.082.144.144 0 0 1 .109.014l-2.566-1.481Z"
            fill="#331083"
        />
        <path
            d="m110.857 366.656-2.561-1.479a1.074 1.074 0 0 1 .484.71 3.618 3.618 0 0 1-.878 2.876 3.987 3.987 0 0 1-.457.471 2.938 2.938 0 0 1-.446.322c-.173.103-.36.178-.556.223a1.053 1.053 0 0 1-.755-.093l2.559 1.478c.231.126.501.16.757.095a1.97 1.97 0 0 0 .556-.223c.157-.094.306-.202.445-.322.166-.144.318-.302.457-.472a3.62 3.62 0 0 0 .878-2.875 1.084 1.084 0 0 0-.483-.711Z"
            fill="#331083"
        />
        <path
            d="M115.427 364.804a.558.558 0 0 1-.2.489l-1.16 1.271a.789.789 0 0 0-.215.346c-.03.385-.093.767-.187 1.141l.1.048.953.426c.132 0 .171.177.095.363l-.656 1.653a.584.584 0 0 1-.228.277.226.226 0 0 1-.141.035l-1.189.167a.29.29 0 0 0-.16.042.592.592 0 0 0-.134.11c-.235.353-.488.694-.759 1.02v.141l.085 1.42a.567.567 0 0 1-.2.488l-1.24 1.076a.35.35 0 0 1-.059.042c-.124.072-.238.045-.266-.085l-.53-1.035a.17.17 0 0 0-.021-.061.159.159 0 0 0-.102-.075.154.154 0 0 0-.064-.004c-.288.136-.59.24-.9.311l-.083.156-.843 1.584a.572.572 0 0 1-.226.284.242.242 0 0 1-.143.037l-1.1-.127c-.124-.017-.171-.185-.095-.372l.447-1.63a.469.469 0 0 0 .021-.351 2.26 2.26 0 0 1-.506-.587l-.13.076-1.271.827a.436.436 0 0 1-.065.048c-.117.068-.228.034-.26-.082l-.308-1.263a.537.537 0 0 1 .19-.484l1.161-1.28a.732.732 0 0 0 .222-.344c.032-.385.092-.768.18-1.145l-.093-.044-.96-.42c-.124-.017-.164-.181-.088-.368l.656-1.653a.596.596 0 0 1 .232-.281.265.265 0 0 1 .137-.041l1.191-.157a.267.267 0 0 0 .158-.042.511.511 0 0 0 .126-.106c.234-.356.491-.698.768-1.024v-.151l-.085-1.41a.553.553 0 0 1 .19-.493l1.247-1.07a.367.367 0 0 1 .068-.049c.119-.069.223-.034.257.082l.523 1.041a.174.174 0 0 0 .071.113.173.173 0 0 0 .129.031c.287-.136.589-.239.9-.307l.092-.16.834-1.588a.58.58 0 0 1 .229-.277.23.23 0 0 1 .14-.035l1.106.123c.124.017.164.181.088.376l-.447 1.63a.512.512 0 0 0-.021.351c.203.163.375.362.506.587l.13-.076 1.271-.827a.47.47 0 0 1 .068-.049c.122-.071.23-.037.257.083l.307 1.258Zm-5.42 5.908a3.802 3.802 0 0 0 1.335-3.347c-.209-.851-.971-1.062-1.8-.58a2.908 2.908 0 0 0-.433.313 3.854 3.854 0 0 0-1.342 3.36c.214.843.967 1.059 1.8.577.158-.093.307-.2.445-.322l-.005-.001Z"
            fill="#560BAD"
        />
        <path
            d="m118.934 347.116-1.348-.6-.14-.069 2.561 1.479.139.069 1.349.6a.19.19 0 0 1 .081.024l-2.561-1.479a.19.19 0 0 0-.081-.024ZM113.884 356.692a.261.261 0 0 0-.117-.17l-2.561-1.479a.264.264 0 0 1 .117.17l.742 1.464a.23.23 0 0 0 .1.148l2.561 1.479a.23.23 0 0 1-.1-.148l-.742-1.464ZM119.39 339.933a.215.215 0 0 0-.157-.02.537.537 0 0 0-.207.11l-1.8 1.167-.185.117 2.561 1.478.185-.116 1.8-1.168a.515.515 0 0 1 .205-.109.217.217 0 0 1 .158.02l-2.56-1.479ZM116.035 345.949l-2.561-1.475a1.524 1.524 0 0 1 .687 1 5.152 5.152 0 0 1-1.246 4.07 5.323 5.323 0 0 1-.653.673c-.193.169-.402.32-.624.451a2.676 2.676 0 0 1-.785.315 1.496 1.496 0 0 1-1.072-.133l2.561 1.479c.329.176.711.223 1.072.132.277-.063.542-.169.785-.314.222-.131.431-.282.624-.451.237-.205.456-.43.653-.673a5.153 5.153 0 0 0 1.246-4.07 1.512 1.512 0 0 0-.24-.573 1.518 1.518 0 0 0-.447-.431Z"
            fill="#4895EF"
        />
        <path
            d="m108.767 355.5-2.451-1.415 1.482-1.626a1.079 1.079 0 0 0 .315-.495 10.5 10.5 0 0 1 .255-1.615l-1.657-.959a.618.618 0 0 1 .034-.226l.939-2.335a.934.934 0 0 1 .139-.236.68.68 0 0 1 .18-.158.367.367 0 0 1 .109-.044.222.222 0 0 1 .089 0l1.691-.245a.28.28 0 0 0 .1 0 .504.504 0 0 0 .136-.055.777.777 0 0 0 .175-.143c.285-.433.591-.851.918-1.253.051-.064.1-.127.157-.189v-.221l-.119-2a.752.752 0 0 1 .181-.6 1.1 1.1 0 0 1 .093-.1l1.113-.96 1.967 1.137a.257.257 0 0 0 .154.028 6.165 6.165 0 0 1 1.268-.427l.123-.222 1.186-2.247a.905.905 0 0 1 .14-.243.694.694 0 0 1 .182-.16.394.394 0 0 1 .119-.047.284.284 0 0 1 .082-.006l1.555.182c.025.003.05.011.072.023l-2.561-1.478a.166.166 0 0 0-.072-.024l-1.555-.182a.284.284 0 0 0-.082.006.372.372 0 0 0-.119.048.679.679 0 0 0-.182.16.915.915 0 0 0-.14.242l-1.186 2.247-.119.218-2.391-1.381a.211.211 0 0 0-.156-.018.35.35 0 0 0-.116.045.629.629 0 0 0-.085.061l-1.763 1.523a.842.842 0 0 0-.274.693l.12 2v.214l-.157.189c-.327.402-.633.82-.918 1.254a.796.796 0 0 1-.175.141.474.474 0 0 1-.136.055.28.28 0 0 1-.1 0l-1.691.245a.266.266 0 0 0-.089 0 .367.367 0 0 0-.109.044.655.655 0 0 0-.178.158.92.92 0 0 0-.14.238l-.939 2.333c-.089.233-.058.434.061.5l1.523.88c-.104.467-.176.94-.215 1.417a1.07 1.07 0 0 1-.315.495l-1.637 1.8a1.36 1.36 0 0 0-.091.095.755.755 0 0 0-.184.6l.443 1.772c.006.031.017.06.034.086a.24.24 0 0 0 .066.065l2.559 1.478a.24.24 0 0 1-.066-.065.234.234 0 0 1-.034-.085l-.443-1.772a.755.755 0 0 1 .184-.6.91.91 0 0 1 .091-.095l.119-.13c.177.275.394.522.642.735a.636.636 0 0 1-.028.488l-.629 2.306c-.092.23-.064.437.061.508l2.561 1.479c-.124-.072-.153-.279-.061-.508l.629-2.306a.636.636 0 0 0 .028-.488 3.464 3.464 0 0 1-.712-.829Z"
            fill="#4895EF"
        />
        <path
            d="M122.494 343.333a.809.809 0 0 1-.274.693l-1.645 1.8c-.146.131-.253.3-.307.489a10.356 10.356 0 0 1-.262 1.612l.139.069 1.349.6c.187.016.242.252.134.518l-.93 2.339a.82.82 0 0 1-.324.395.315.315 0 0 1-.2.051l-1.684.24a.41.41 0 0 0-.236.061.78.78 0 0 0-.173.141c-.33.505-.692.989-1.083 1.448l.01.208.119 2a.791.791 0 0 1-.274.684l-1.763 1.523a.584.584 0 0 1-.1.071c-.17.1-.32.054-.366-.122l-.742-1.464a.223.223 0 0 0-.032-.087.241.241 0 0 0-.239-.113c-.405.187-.83.329-1.266.423l-.131.228-1.185 2.247a.845.845 0 0 1-.325.4.321.321 0 0 1-.191.048l-1.562-.177c-.178-.031-.233-.266-.127-.532l.629-2.306a.645.645 0 0 0 .028-.488 3.42 3.42 0 0 1-.715-.839l-.178.1-1.8 1.172a.591.591 0 0 1-.095.069c-.167.1-.322.054-.362-.124l-.443-1.772a.787.787 0 0 1 .274-.694l1.637-1.8a1.09 1.09 0 0 0 .314-.495 10.5 10.5 0 0 1 .255-1.615l-.131-.066-1.357-.591c-.178-.021-.24-.252-.134-.527l.939-2.333a.814.814 0 0 1 .318-.4.3.3 0 0 1 .2-.047l1.691-.245a.376.376 0 0 0 .233-.059.777.777 0 0 0 .175-.143c.329-.496.688-.972 1.074-1.425v-.214l-.119-2a.775.775 0 0 1 .274-.693l1.763-1.523a.69.69 0 0 1 .082-.06c.171-.1.331-.058.37.124l.744 1.465c.01.062.043.118.094.156a.243.243 0 0 0 .177.044 6.102 6.102 0 0 1 1.274-.428l.122-.222 1.186-2.247a.808.808 0 0 1 .322-.4.353.353 0 0 1 .2-.052l1.555.182c.178.021.242.26.134.526l-.636 2.311a.645.645 0 0 0-.028.488c.284.237.526.521.716.839l.185-.116 1.8-1.168a.493.493 0 0 1 .088-.061c.174-.1.328-.059.376.112l.439 1.772Zm-7.671 8.363a5.401 5.401 0 0 0 1.9-4.743c-.3-1.2-1.37-1.5-2.542-.819a4.07 4.07 0 0 0-.629.454 5.388 5.388 0 0 0-1.892 4.738c.3 1.2 1.37 1.5 2.541.82.222-.13.431-.281.624-.451l-.002.001Z"
            fill="#4CC9F0"
        />
        <path
            d="m136.645 358.194 2.561 1.479a.233.233 0 0 1 .049.021l-2.561-1.479a.233.233 0 0 0-.049-.021Z"
            fill="#D43E3E"
        />
        <path
            d="M138.09 348.075a.302.302 0 0 0-.219-.024.75.75 0 0 0-.226.095l-2.51 1.328a.708.708 0 0 1-.188.079l2.561 1.479a.701.701 0 0 0 .187-.079l2.511-1.328a.75.75 0 0 1 .226-.095.313.313 0 0 1 .219.023l-2.561-1.478ZM128.458 369.605a.403.403 0 0 0-.177-.3l-2.561-1.478a.392.392 0 0 1 .177.3l.771 2.24a.315.315 0 0 0 .14.249l2.561 1.479a.314.314 0 0 1-.14-.249l-.771-2.241ZM132.296 354.609l-2.561-1.479a2.26 2.26 0 0 1 1.008 1.753 7.356 7.356 0 0 1-1.773 5.144 6.912 6.912 0 0 1-1.247 1.2 5.185 5.185 0 0 1-.478.315 3.667 3.667 0 0 1-1.07.43 2.021 2.021 0 0 1-1.451-.18l2.561 1.479c.444.239.961.303 1.451.18a3.667 3.667 0 0 0 1.07-.43c.165-.096.324-.201.478-.315.464-.347.883-.75 1.247-1.2a7.365 7.365 0 0 0 1.773-5.144 2.254 2.254 0 0 0-1.008-1.753ZM122.07 366.844l-2.559-1.479c.193.487.463.939.8 1.34.051.231.019.473-.089.683l-1.1 3.16c-.154.325-.134.646.049.752l2.561 1.478c-.184-.1-.2-.426-.051-.751l1.1-3.16c.109-.21.14-.452.089-.683a4.937 4.937 0 0 1-.8-1.34ZM128.881 347.133a.33.33 0 0 1-.14-.042l2.559 1.479a.354.354 0 0 0 .141.042c.262-.088.529-.162.8-.219.291-.062.585-.103.881-.123l.191-.3 1.8-2.95c.043-.089.095-.173.157-.25a.973.973 0 0 1 .252-.222.53.53 0 0 1 .157-.062.293.293 0 0 1 .15 0l1.968.592a.322.322 0 0 1 .061.024l-2.561-1.479a.322.322 0 0 0-.061-.024l-1.968-.592a.293.293 0 0 0-.15 0 .584.584 0 0 0-.156.062.926.926 0 0 0-.253.222 1.297 1.297 0 0 0-.157.25l-1.8 2.951-.191.3c-.296.02-.59.061-.881.123-.27.057-.537.13-.799.218Z"
            fill="#B5179E"
        />
        <path
            d="M125.039 353.714c.063-.037.122-.081.177-.131a18.473 18.473 0 0 1 1.566-1.837.781.781 0 0 0 .014-.293l.1-2.879c-.013-.274.08-.543.259-.751a.95.95 0 0 1 .177-.17l2.441-1.792a.9.9 0 0 1 .072-.048.53.53 0 0 1 .158-.064.281.281 0 0 1 .205.025l-2.559-1.479a.29.29 0 0 0-.206-.025.514.514 0 0 0-.157.064c-.024.014-.048.03-.074.048l-2.441 1.792a.91.91 0 0 0-.175.17 1.07 1.07 0 0 0-.26.751l-.1 2.879a.781.781 0 0 1-.014.293 19.267 19.267 0 0 0-1.566 1.837c-.055.05-.114.094-.177.132a.632.632 0 0 1-.185.075.37.37 0 0 1-.187 0l-2.18-.014a.314.314 0 0 0-.161 0 .514.514 0 0 0-.157.064.9.9 0 0 0-.249.219c-.063.076-.115.16-.157.249l-1.483 3.121c-.16.338-.134.656.044.758l.136.078 1.579 1.072.163.119a16.124 16.124 0 0 0-.537 2.243 1.42 1.42 0 0 1-.242.431 1.204 1.204 0 0 1-.211.205l-2.323 2.213c-.065.05-.124.107-.175.17a1.07 1.07 0 0 0-.26.751l.339 2.624a.307.307 0 0 0 .14.245l2.561 1.479a.307.307 0 0 1-.14-.245l-.339-2.624a1.07 1.07 0 0 1 .26-.751.971.971 0 0 1 .175-.17l2.323-2.213c.078-.059.149-.128.211-.205a1.42 1.42 0 0 0 .242-.431c.125-.759.305-1.509.537-2.243l-.163-.119-1.661-1.127-.071-.041c-.158-.113-.181-.414-.027-.74l1.483-3.122c.042-.088.094-.171.156-.247a.903.903 0 0 1 .25-.219.514.514 0 0 1 .157-.064.314.314 0 0 1 .161 0l2.18.014a.394.394 0 0 0 .187 0 .647.647 0 0 0 .184-.077Z"
            fill="#B5179E"
        />
        <path
            d="M141.129 352.419a1.122 1.122 0 0 1-.435.921l-2.323 2.221c-.21.159-.368.378-.453.628a16.158 16.158 0 0 1-.537 2.243l.164.127 1.66 1.118c.225.074.273.41.1.779l-1.483 3.122a1.078 1.078 0 0 1-.406.468.402.402 0 0 1-.318.059l-2.18-.014a.465.465 0 0 0-.37.071.948.948 0 0 0-.177.132 16.912 16.912 0 0 1-1.568 1.835.786.786 0 0 0-.014.294l-.1 2.879a1.108 1.108 0 0 1-.436.921l-2.441 1.8c-.327.2-.544.1-.581-.178l-.771-2.24a.354.354 0 0 0-.318-.341 6.861 6.861 0 0 1-1.677.351l-.191.29-1.8 2.951a1.053 1.053 0 0 1-.4.471.402.402 0 0 1-.311.061l-1.968-.584c-.232-.069-.273-.42-.1-.775l1.1-3.16c.109-.21.14-.452.089-.683a4.952 4.952 0 0 1-.8-1.34.767.767 0 0 0-.187.079l-2.5 1.333c-.327.2-.552.106-.588-.174l-.339-2.624a1.122 1.122 0 0 1 .436-.921l2.323-2.213c.209-.164.366-.385.453-.636.126-.76.305-1.509.537-2.243l-.163-.119-1.661-1.127c-.225-.065-.273-.411-.1-.781l1.483-3.122c.087-.192.228-.354.406-.467a.399.399 0 0 1 .318-.059l2.18.014a.484.484 0 0 0 .372-.071.989.989 0 0 0 .177-.131 19.181 19.181 0 0 1 1.567-1.837.76.76 0 0 0 .014-.293l.1-2.879a1.122 1.122 0 0 1 .435-.921l2.441-1.792c.025-.018.049-.034.072-.048.256-.148.472-.062.509.218l.771 2.24a.355.355 0 0 0 .318.339 6.545 6.545 0 0 1 1.677-.342l.191-.3 1.8-2.95c.088-.194.23-.358.409-.472a.4.4 0 0 1 .307-.059l1.968.592c.232.061.273.41.1.766l-1.1 3.159a1.02 1.02 0 0 0-.089.684c.336.401.606.853.8 1.339a.701.701 0 0 0 .187-.079l2.511-1.328c.321-.192.544-.11.581.17l.329 2.628Zm-10.847 10.287a7.66 7.66 0 0 0 3.02-6.346c-.252-1.91-1.779-2.52-3.527-1.5a5.388 5.388 0 0 0-.478.314 7.678 7.678 0 0 0-3.02 6.356c.252 1.9 1.779 2.51 3.527 1.495.165-.096.325-.201.478-.315v-.004Z"
            fill="#F72585"
        />
        <path d="m352.702 227.427-153.5 89.2Z" fill="#35404D" />
        <path d="m352.702 227.427-153.5 89.2" stroke="#DEDDE2" />
        <path
            d="m289.652 178.235 124.652-71.88c6.722-3.876 17.619-3.876 24.341 0l124.654 71.877c6.722 3.876 6.721 10.16 0 14.036l-124.656 71.884c-6.722 3.876-17.62 3.876-24.341 0l-124.65-71.882c-6.721-3.876-6.721-10.159 0-14.035Z"
            fill="#282739"
        />
        <path
            d="M534.454 158.17h-67.255l-40.87 53.6h108.125l46.749-26.8-46.749-26.8ZM420.819 141.422h-39.845l-12.661 7.258-1.025-1.083-4.515 2.6 4.489 2.573h2.972l10.737 6.155h39.845l15.263-8.75-15.26-8.753Z"
            fill="#101015"
        />
        <path
            d="M398.183 154.401h-39.848l-12.661 7.258-1.025-1.083-4.515 2.6 4.489 2.574h2.974l10.738 6.151h39.845l15.263-8.75-15.26-8.75Z"
            fill="#101015"
        />
        <path
            d="M375.472 167.364h-39.845l-12.661 7.258-1.025-1.082-4.515 2.6 4.489 2.573h2.974l10.737 6.155h39.846l15.263-8.75-15.263-8.754Z"
            fill="#101015"
        />
        <path
            d="M401.54 182.608h-39.845l-12.661 7.258-1.025-1.083-4.515 2.6 4.489 2.573h2.974l10.737 6.155h39.845l15.263-8.75-15.262-8.753Z"
            fill="#101015"
        />
        <path
            d="M287.611 181.006c-1.503 1.503-2.18 3.189-1.958 4.874.27 2.045 1.868 4.007 4.499 5.525l124.651 71.88c3.102 1.788 7.247 2.773 11.671 2.773 4.425 0 8.57-.985 11.671-2.773l124.651-71.88c.998-.575 1.853-1.216 2.542-1.905 1.503-1.504 2.18-3.189 1.958-4.874-.27-2.045-1.868-4.007-4.5-5.525l-124.651-71.88c-3.101-1.788-7.246-2.773-11.671-2.773-4.424 0-8.569.985-11.671 2.773l-124.651 71.88c-.997.575-1.852 1.216-2.541 1.905Zm-.707-.707c.738-.738 1.654-1.433 2.749-2.064l124.651-71.88c6.721-3.876 17.619-3.876 24.341 0l124.651 71.88c6.721 3.876 6.721 10.16 0 14.036l-124.651 71.88c-6.722 3.876-17.62 3.876-24.341 0l-124.651-71.88c-5.627-3.245-6.543-8.178-2.749-11.972Z"
            fill="#DEDDE2"
        />
        <path
            d="M466.192 115.477h-39.846l-12.661 7.258-1.024-1.082-4.515 2.6 4.489 2.573h2.974l10.737 6.155h39.844l15.263-8.75-15.261-8.754Z"
            fill="#93A865"
        />
        <path
            d="M417.082 124.245v-7.785l-4.489 2.573v7.785l4.489-2.573Z"
            fill="#A67C52"
        />
        <path
            d="M408.104 124.245v-7.785l4.489 2.573v7.785l-4.489-2.573Z"
            fill="#C69C6D"
        />
        <path
            d="m412.593 113.886-4.489 2.574 4.489 2.573 4.488-2.573-4.488-2.574Z"
            fill="#F2F2F2"
        />
        <path
            d="M427.855 110.801V99.695l-15.263 8.75v11.105l15.263-8.749Z"
            fill="#75934C"
        />
        <path
            d="M397.329 110.801V99.695l15.263 8.75v11.105l-15.263-8.749Z"
            fill="#AAD86F"
        />
        <path
            d="m412.592 90.945-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M427.855 96.269V85.164l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M397.329 96.269V85.164l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m412.592 76.414-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M427.855 81.738V70.633l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M397.329 81.738V70.633l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m412.592 61.882-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#C7F08F"
        />
        <path
            d="M371.755 150.189v-7.788l-4.489 2.573v7.785l4.489-2.57Z"
            fill="#A67C52"
        />
        <path
            d="M362.776 150.189v-7.788l4.489 2.573v7.785l-4.489-2.57Z"
            fill="#C69C6D"
        />
        <path
            d="m367.265 139.83-4.489 2.571 4.489 2.573 4.489-2.573-4.489-2.571Z"
            fill="#F2F2F2"
        />
        <path
            d="M382.528 136.744v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M352.002 136.744v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m367.265 116.888-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M382.528 122.212v-11.105l-15.263 8.75v11.106l15.263-8.751Z"
            fill="#75934C"
        />
        <path
            d="M352.002 122.212v-11.105l15.263 8.75v11.106l-15.263-8.751Z"
            fill="#AAD86F"
        />
        <path
            d="m367.265 102.357-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M382.528 107.682V96.576l-15.263 8.75v11.105l15.263-8.749Z"
            fill="#75934C"
        />
        <path
            d="M352.002 107.682V96.576l15.263 8.75v11.105l-15.263-8.749Z"
            fill="#AAD86F"
        />
        <path
            d="m367.265 87.826-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#C7F08F"
        />
        <path
            d="M349.044 163.153v-7.785l-4.489 2.573v7.785l4.489-2.573Z"
            fill="#A67C52"
        />
        <path
            d="M340.064 163.153v-7.785l4.489 2.573v7.785l-4.489-2.573Z"
            fill="#C69C6D"
        />
        <path
            d="m344.554 152.794-4.489 2.573 4.489 2.573 4.489-2.573-4.489-2.573Z"
            fill="#F2F2F2"
        />
        <path
            d="M359.817 149.708v-11.107l-15.263 8.75v11.106l15.263-8.749Z"
            fill="#75934C"
        />
        <path
            d="M329.291 149.708v-11.107l15.263 8.75v11.106l-15.263-8.749Z"
            fill="#AAD86F"
        />
        <path
            d="m344.554 129.852-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M359.817 135.176v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M329.291 135.176v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m344.554 115.321-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M359.817 120.645V109.54l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M329.291 120.645V109.54l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m344.554 100.79-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#C7F08F"
        />
        <path
            d="M326.406 176.135v-7.785l-4.489 2.573v7.785l4.489-2.573Z"
            fill="#A67C52"
        />
        <path
            d="M317.427 176.135v-7.785l4.489 2.573v7.785l-4.489-2.573Z"
            fill="#C69C6D"
        />
        <path
            d="m321.917 165.776-4.489 2.573 4.489 2.573 4.489-2.573-4.489-2.573Z"
            fill="#F2F2F2"
        />
        <path
            d="M337.179 162.69v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M306.652 162.69v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m321.916 142.835-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M337.179 148.159v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M306.652 148.159v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m321.916 128.301-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M337.179 133.628v-11.105l-15.263 8.75v11.106l15.263-8.751Z"
            fill="#75934C"
        />
        <path
            d="M306.652 133.628v-11.105l15.263 8.75v11.106l-15.263-8.751Z"
            fill="#AAD86F"
        />
        <path
            d="m321.916 113.773-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#C7F08F"
        />
        <path
            d="M352.474 191.379v-7.785l-4.489 2.573v7.785l4.489-2.573Z"
            fill="#A67C52"
        />
        <path
            d="M343.495 191.379v-7.785l4.489 2.573v7.785l-4.489-2.573Z"
            fill="#C69C6D"
        />
        <path
            d="m347.984 181.02-4.489 2.573 4.489 2.573 4.489-2.573-4.489-2.573Z"
            fill="#F2F2F2"
        />
        <path
            d="M363.246 177.934v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M332.721 177.934v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m347.984 158.078-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M363.246 163.401v-11.1l-15.263 8.75v11.105l15.263-8.755Z"
            fill="#75934C"
        />
        <path
            d="M332.721 163.401v-11.1l15.263 8.75v11.105l-15.263-8.755Z"
            fill="#AAD86F"
        />
        <path
            d="m347.984 143.547-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M363.246 148.871v-11.105l-15.263 8.75v11.105l15.263-8.75Z"
            fill="#75934C"
        />
        <path
            d="M332.721 148.871v-11.105l15.263 8.75v11.105l-15.263-8.75Z"
            fill="#AAD86F"
        />
        <path
            d="m347.984 129.016-15.263 8.75 15.263 8.75 15.263-8.75-15.263-8.75Z"
            fill="#C7F08F"
        />
        <path
            d="M463.11 147.61v-7.773l-4.482 2.569v7.773l4.482-2.569Z"
            fill="#A67C52"
        />
        <path
            d="M454.146 147.61v-7.773l4.482 2.569v7.773l-4.482-2.569Z"
            fill="#C69C6D"
        />
        <path
            d="m458.628 137.268-4.482 2.569 4.482 2.569 4.482-2.569-4.482-2.569Z"
            fill="#F2F2F2"
        />
        <path
            d="M473.867 134.187v-11.086l-15.238 8.735v11.087l15.238-8.736Z"
            fill="#75934C"
        />
        <path
            d="M443.39 134.187v-11.086l15.238 8.735v11.087l-15.238-8.736Z"
            fill="#AAD86F"
        />
        <path
            d="m458.629 114.363-15.238 8.736 15.238 8.735 15.238-8.735-15.238-8.736Z"
            fill="#75934C"
        />
        <path
            d="M473.867 119.678v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M443.39 119.678v-11.087l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m458.629 99.856-15.238 8.735 15.238 8.735 15.238-8.735-15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M473.867 105.172V94.085l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M443.39 105.172V94.085l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m458.629 85.349-15.238 8.735 15.238 8.735 15.238-8.735-15.238-8.735Z"
            fill="#C7F08F"
        />
        <path
            d="M489.135 162.828v-7.772l-4.482 2.569v7.776l4.482-2.573Z"
            fill="#A67C52"
        />
        <path
            d="M480.172 162.828v-7.772l4.482 2.569v7.776l-4.482-2.573Z"
            fill="#C69C6D"
        />
        <path
            d="m484.654 152.485-4.482 2.569 4.482 2.569 4.482-2.569-4.482-2.569Z"
            fill="#F2F2F2"
        />
        <path
            d="M499.892 149.4v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M469.416 149.4v-11.087l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m484.654 129.582-15.238 8.735 15.238 8.735 15.238-8.735-15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M499.892 134.9v-11.09l-15.238 8.736v11.087l15.238-8.733Z"
            fill="#75934C"
        />
        <path
            d="M469.416 134.9v-11.09l15.238 8.736v11.087l-15.238-8.733Z"
            fill="#AAD86F"
        />
        <path
            d="m484.654 115.075-15.238 8.735 15.238 8.736 15.238-8.736-15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M499.892 120.39V109.3l-15.238 8.735v11.087l15.238-8.732Z"
            fill="#75934C"
        />
        <path
            d="M469.416 120.39V109.3l15.238 8.735v11.087l-15.238-8.732Z"
            fill="#AAD86F"
        />
        <path
            d="m484.654 100.567-15.238 8.735 15.238 8.735 15.238-8.735-15.238-8.735Z"
            fill="#C7F08F"
        />
        <path
            d="M512.708 174.268v-7.773l-4.482 2.569v7.772l4.482-2.568Z"
            fill="#A67C52"
        />
        <path
            d="M503.744 174.268v-7.773l4.482 2.569v7.772l-4.482-2.568Z"
            fill="#C69C6D"
        />
        <path
            d="m508.225 163.926-4.482 2.569 4.482 2.569 4.482-2.569-4.482-2.569Z"
            fill="#F2F2F2"
        />
        <path
            d="M523.464 160.845v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M492.987 160.845v-11.087l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m508.225 141.022-15.238 8.735 15.238 8.735 15.238-8.735-15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M523.464 146.338v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M492.987 146.338v-11.087l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m508.225 126.515-15.238 8.735 15.238 8.735 15.238-8.735-15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M523.464 131.83v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M492.987 131.83v-11.087l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m508.225 112.008-15.238 8.736 15.238 8.735 15.238-8.735-15.238-8.736Z"
            fill="#C7F08F"
        />
        <path
            d="M538.736 189.487v-7.773l-4.482 2.569v7.773l4.482-2.569Z"
            fill="#A67C52"
        />
        <path
            d="M529.77 189.487v-7.773l4.482 2.569v7.773l-4.482-2.569Z"
            fill="#C69C6D"
        />
        <path
            d="m534.252 179.145-4.482 2.569 4.482 2.569 4.482-2.569-4.482-2.569Z"
            fill="#F2F2F2"
        />
        <path
            d="M549.49 176.064v-11.087l-15.238 8.736v11.088l15.238-8.737Z"
            fill="#75934C"
        />
        <path
            d="M519.013 176.064v-11.087l15.238 8.736v11.088l-15.238-8.737Z"
            fill="#AAD86F"
        />
        <path
            d="m534.252 156.241-15.238 8.735 15.238 8.736 15.238-8.736-15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M549.49 161.556v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M519.013 161.556v-11.087l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m534.252 141.733-15.238 8.736 15.238 8.734 15.238-8.734-15.238-8.736Z"
            fill="#75934C"
        />
        <path
            d="M549.49 147.049v-11.087l-15.238 8.735v11.087l15.238-8.735Z"
            fill="#75934C"
        />
        <path
            d="M519.013 147.049v-11.087l15.238 8.735v11.087l-15.238-8.735Z"
            fill="#AAD86F"
        />
        <path
            d="m534.252 127.226-15.238 8.735 15.238 8.735 15.238-8.735-15.238-8.735Z"
            fill="#C7F08F"
        />
        <path
            d="M379.58 185.031v-54.184l46.749 26.8v54.183l-46.749-26.799Z"
            fill="#DEDDE2"
        />
        <path
            d="M473.077 185.031v-54.184l-46.749 26.8v54.183l46.749-26.799Z"
            fill="#ADABB9"
        />
        <path
            d="m426.328 104.048-46.749 26.8 46.749 26.8 46.749-26.8-46.749-26.8Z"
            fill="#E3DAD7"
        />
        <path
            d="M379.58 131.027V76.844l46.749 26.8v54.184l-46.749-26.801Z"
            fill="#DEDDE2"
        />
        <path
            d="M473.077 131.027V76.844l-46.749 26.8v54.184l46.749-26.801Z"
            fill="#ADABB9"
        />
        <path
            d="m426.328 50.045-46.749 26.8 46.749 26.8 46.749-26.8-46.749-26.8Z"
            fill="#D7D6DD"
        />
        <path
            d="M445.341 115.184v-9.344l11.362-6.56v9.344l8.958-5.172v11.191l-8.958 5.172v9.43l-11.362 6.56v-9.43l-8.959 5.173v-11.191l8.959-5.173ZM408.107 115.184v-9.344l-11.362-6.56v9.344l-8.958-5.172v11.191l8.958 5.172v9.43l11.362 6.56v-9.43l8.959 5.173v-11.191l-8.959-5.173Z"
            fill="#4361EE"
        />
        <path
            d="m419.624 154.776-33.457-19.04.014 44.265 33.442 19.032.001-44.257Z"
            fill="#ADABB9"
        />
        <path
            d="m387.701 179.172 31.923 18.159v-42.555l-31.935-18.166.012 42.562Z"
            fill="#FAF8F8"
        />
        <path
            d="m433.391 154.776 33.457-19.04-.013 44.265-33.443 19.032-.001-44.257Z"
            fill="#888595"
        />
        <path
            d="m465.314 179.172-31.923 18.159v-42.555l31.935-18.166-.012 42.562Z"
            fill="#E9E5F2"
        />
        <path
            d="m426.328 50.045-46.748 26.8 46.748 26.8 46.749-26.8-46.749-26.8Zm-36.509 26.8 36.509-20.93 36.51 20.93-36.51 20.929-36.509-20.929Z"
            fill="#F4EFED"
        />
        <path
            d="m223.298 289.73-.01 3.8-2.085-3.678.011-3.8 2.084 3.678Z"
            fill="#1B2127"
        />
        <path
            d="m227.563 287.241-4.264 2.488-2.085-3.68 6.349 1.192Z"
            fill="#35404D"
        />
        <path
            d="m227.577 287.243 10.8 6.235-4.279 2.485-10.8-6.234 4.279-2.486Z"
            fill="#FBAB20"
        />
        <path
            d="m234.096 295.963-.01 3.8-10.8-6.235.01-3.8 10.8 6.235Z"
            fill="#8D5700"
        />
        <path
            d="m239.376 293.377-5.449 3.167.169-.581 4.279-2.485 1.001-.101Z"
            fill="#35404D"
        />
        <path
            d="m253.68 307.948-.012 3.8-19.751-11.4.01-3.8 19.753 11.4Z"
            fill="#B73D34"
        />
        <path
            d="m233.927 296.544 5.449-3.167 19.753 11.408-5.45 3.166-19.752-11.407Z"
            fill="#EB5A49"
        />
        <path
            d="m260.535 305.594-5.448 3.167-1.133.658-.114.066a1.424 1.424 0 0 1-1.288 0l-1.2-.7-5.837-3.363-.645-.373c-.025-.018-.053-.034-.08-.051a3.144 3.144 0 0 0-1.251-.288 3.142 3.142 0 0 1-1.113-.216.439.439 0 0 1-.232-.316c-.122-.692 1.743-.784 2.97-.389.502.171.986.389 1.446.652l.3.172 5.832 3.367.446.259.493-.288 5.45-3.166 1.404.809Z"
            fill="#35404D"
        />
        <path
            d="m253.953 309.419-.114.066a1.08 1.08 0 0 1-.284.11c-.035.008-.07.01-.105.015a1.31 1.31 0 0 1-.216.024c-.044 0-.084 0-.128-.006a1.348 1.348 0 0 1-.557-.146l-1.2-.7-5.832-3.367-.645-.372c-.025-.018-.053-.034-.08-.051a1.417 1.417 0 0 0-.184-.089c-.013 0-.027-.006-.039-.01a2.582 2.582 0 0 0-.441-.117c-.038-.006-.077-.013-.115-.017a7.294 7.294 0 0 0-.471-.056 19.426 19.426 0 0 1-.469-.049c-.032 0-.065-.007-.1-.013a2.112 2.112 0 0 1-.4-.093 1.053 1.053 0 0 1-.152-.062.448.448 0 0 1-.238-.381l-.013 3.8a.45.45 0 0 0 .239.379.94.94 0 0 0 .111.053c.013 0 .031.006.044.01.127.043.259.074.392.093l.1.011c.148.02.3.034.464.049.164.015.325.034.484.059l.094.013c.153.026.304.066.45.119.077.027.152.06.224.1l.08.052.642.371 5.845 3.369 1.2.7a.622.622 0 0 0 .236.089 1.348 1.348 0 0 0 .324.056c.042.004.085.006.127.006.072-.002.144-.01.215-.024.037-.006.073-.007.105-.015.1-.022.197-.058.287-.108l.112-.067 1.133-.658.011-3.8-1.136.657Z"
            fill="#1C2128"
        />
        <path
            d="m263.271 307.174-.01 3.8-.587.339.012-3.8.585-.339ZM258.409 310l-.01 3.8-.587.341.011-3.8.586-.341Z"
            fill="#731F00"
        />
        <path
            d="m257.823 310.34-.01 3.8-2.736-1.58.01-3.8 2.736 1.58Z"
            fill="#B73D34"
        />
        <path
            d="m260.535 305.594 2.736 1.58-.585.339-4.279 2.487-.586.339-2.736-1.578 5.45-3.167Z"
            fill="#EB5A49"
        />
        <path
            d="m263.795 308.15-.01 3.8-4.279 2.485.01-3.8 4.279-2.485Z"
            fill="#1E242B"
        />
        <path
            d="m259.521 310.64-.01 3.8-1.108-.64.01-3.8 1.108.64Z"
            fill="#1D232A"
        />
        <path
            d="m263.794 308.154-4.279 2.487-1.109-.64 4.279-2.487 1.109.64Z"
            fill="#35404D"
        />
        <path
            d="m277.828 249.173-13.535 7.864-13.62-7.864h27.155Z"
            fill="#D7E7F7"
        />
        <path
            d="m283.663 256.022-41.9 24.35-4.585-2.648 41.9-24.348 4.585 2.646ZM292.424 261.08l-41.9 24.35-4.59-2.651 41.9-24.348 4.59 2.649Z"
            fill="#F8F9FC"
        />
        <path
            d="m292.423 261.08-23.3 13.524-4.59-2.651 23.3-13.523 4.59 2.65ZM300.974 266.017l-41.9 24.35-4.581-2.642 41.9-24.35 4.581 2.642ZM298.131 278.697l-29.538 17.164-4.59-2.649 29.536-17.166 4.592 2.651Z"
            fill="#35404D"
        />
        <path
            d="m277.828 249.173-13.533 7.863-13.62-7.863-35.368 20.554 60.74 35.068 48.9-28.418-47.119-27.204Zm-40.65 28.554 41.9-24.35 4.587 2.647-41.9 24.35-4.587-2.647Zm8.756 5.055 41.9-24.348 4.59 2.648-41.899 24.345-4.591-2.645Zm8.555 4.941 41.9-24.351 4.585 2.647-41.9 24.35-4.585-2.646Zm14.1 8.14-4.59-2.648 29.537-17.166 4.591 2.651-29.538 17.163Z"
            fill="#F8F9FC"
        />
        <path
            d="m276.046 304.798-60.74-35.069-.005 1.869 60.74 35.069 48.9-28.417.007-1.871-48.902 28.419Z"
            fill="#D7E7F7"
        />
        <path
            d="M247.537 277.724c.172.096.328.219.461.364.069.077.127.163.174.256.086.16.118.344.093.524a1.33 1.33 0 0 1-.721.905 2.9 2.9 0 0 1-.638.273l-.135.037a4.18 4.18 0 0 1-2.211-.063 2.944 2.944 0 0 1-.561-.245 1.447 1.447 0 0 1-.143-.09 1.686 1.686 0 0 1-.325-.283c-.562-.628-.236-1.39.7-1.806a3.16 3.16 0 0 1 .388-.142c.141-.041.283-.075.427-.1a3.898 3.898 0 0 1 2.491.37Z"
            fill="#FFBF00"
        />
        <path
            d="M255.032 277.721a.963.963 0 0 0 .2.516l-6.962.631a.865.865 0 0 0-.093-.524l6.855-.623Z"
            fill="#02567D"
        />
        <path
            d="M259.308 276.652c.175.098.333.224.468.373.624.713.138 1.588-1.092 1.947a4.207 4.207 0 0 1-2.116.047 3.05 3.05 0 0 1-.8-.309 1.78 1.78 0 0 1-.544-.47.966.966 0 0 1-.2-.516c-.031-.545.471-1.077 1.368-1.34a3.978 3.978 0 0 1 1.1-.156c.302-.003.604.028.9.091.321.062.63.175.916.333Z"
            fill="#E54332"
        />
        <path
            d="m255.515 260.689.261.5-5.489.967a.876.876 0 0 0-.1-.538l5.328-.929Z"
            fill="#02567D"
        />
        <path
            d="M249.558 261.011c.174.098.332.224.467.373.064.073.12.153.166.24.09.163.125.352.1.538-.072.484-.558.936-1.364 1.174a4.25 4.25 0 0 1-1.366.146 3.54 3.54 0 0 1-1.536-.417 1.85 1.85 0 0 1-.464-.37c-.634-.72-.148-1.594 1.082-1.954a3.964 3.964 0 0 1 2.915.27Z"
            fill="#E54332"
        />
        <path
            d="m248.466 263.438.773 2.856a4.11 4.11 0 0 0-.9.069l-.78-2.879c.303.017.607.002.907-.046Z"
            fill="#02567D"
        />
        <path
            d="M250.88 266.715c.174.097.331.222.464.371a.92.92 0 0 1 .082 1.23c-.137.18-.309.331-.507.444a2.875 2.875 0 0 1-.656.278 4.088 4.088 0 0 1-2.658-.136 2.049 2.049 0 0 1-.614-.388 1.506 1.506 0 0 1-.112-.114c-.624-.714-.139-1.588 1.1-1.954a4.12 4.12 0 0 1 1.26-.153 3.574 3.574 0 0 1 1.641.422ZM260.698 270.206c.13.072.247.164.347.274.467.526.1 1.181-.817 1.444a3.098 3.098 0 0 1-1.576.031 2.288 2.288 0 0 1-.581-.228 1.403 1.403 0 0 1-.347-.276.688.688 0 0 1-.153-.725c.086-.196.23-.361.413-.471.172-.11.36-.193.557-.247a2.91 2.91 0 0 1 2.157.198Z"
            fill="#FFBF00"
        />
        <path
            d="m251.426 268.317 6.559 1.941a1.038 1.038 0 0 0-.413.471l-6.653-1.968c.197-.112.37-.263.507-.444ZM258.4 276.317a4.128 4.128 0 0 0-.9-.091l1.153-4.268c.296.071.601.099.905.083l-1.158 4.276Z"
            fill="#02567D"
        />
        <path
            d="M243.143 271.138c.101.059.197.121.287.186.156.112.3.24.429.384.9 1.014.318 2.239-1.274 2.849a4.57 4.57 0 0 1-.4.134c-.141.04-.278.076-.42.107a6 6 0 0 1-4.036-.513 2.834 2.834 0 0 1-.71-.565 1.575 1.575 0 0 1-.415-.859 1.288 1.288 0 0 1 .045-.524 2.78 2.78 0 0 1 2.04-1.611 6.228 6.228 0 0 1 4.085.228c.131.056.256.118.369.184Z"
            fill="#134663"
        />
        <path
            d="M246.989 268.515a2.035 2.035 0 0 0 .614.388l-4.175 2.421a2.616 2.616 0 0 0-.287-.186 4.45 4.45 0 0 0-.365-.186l4.213-2.437ZM244.621 277.453a3.313 3.313 0 0 0-.387.141l-1.164-1.32-1.3-1.477a5.734 5.734 0 0 0 .82-.241l2.464 2.8a3.762 3.762 0 0 0-.433.097Z"
            fill="#02567D"
        />
        <path
            d="M256.379 260.374c.116.064.221.148.309.247.419.467.1 1.042-.716 1.278a2.578 2.578 0 0 1-1.9-.172 1.25 1.25 0 0 1-.309-.247c-.419-.467-.1-1.042.716-1.278a2.572 2.572 0 0 1 1.9.172Z"
            fill="#E54332"
        />
    </svg>
)

export default SvgComponent
